import axios from 'axios'
import router from '../router'
import store from '../store'
import config from '../config/config'

const UNAUTHORIZED = 401;
const onUnauthorized = () => {
  console.log("onUnauthorized");
  store.commit('LOGOUT')
  router.push(`/login?rPath=${encodeURIComponent(location.pathname)}`);
}
const DOMAIN = config.getBackendUrl;

console.log(DOMAIN);

const request = (method, url, data) => {
  const target_url = DOMAIN + url;
  console.log(target_url);
  return axios({
    method,
    url: target_url,
    data,
  })
    .then(result => result.data)
    .catch(result => {
      const response = result.response;
      if (!response) {
        // 네트워크/SSL 오류 등으로 response 없음
        const msg = result.message || '서버에 연결할 수 없습니다.';
        console.error('API request failed:', msg);
        throw msg;
      }
      const status = response.status;
      const { err_message, err_code } = response.data || {};
      if (status === UNAUTHORIZED) {
        onUnauthorized()
      }
      throw err_message != null ? err_message : `요청 실패 (${status})`;
    })
}

export const setAuthInHeader = session_id => {
  axios.defaults.headers.common['Authorization'] = session_id ? `Bearer ${session_id}` : null;
}




export const auth = {
  login(user_id, password) {
    return request('post', '/api/login', { user_id, password })
  },
  sign_in(user_id, password) {
    return request('post', '/api/signin', { user_id, password })
  }
}

export const games = {
  get_games(user_id) {
    return request('post', '/api/get_games', { user_id })
  },
}

// [스냅퀴즈 · 서버 설정] Git Patch / 서버 응답 확인 — CMS_Back 이 대상 서버로 호출
export const snapquiz_setting = {
  git_patch(admin_user) {
    return request('post', '/api/snapquiz/git_patch', { admin_user })
  },
  check_server(admin_user) {
    return request('post', '/api/snapquiz/check_server', { admin_user })
  },
}

// [스냅퀴즈 · 보상형 하우스애드] tb_reward_ad / tb_reward_ad_block / tb_reward_ad_log
export const snapquiz_housead = {
  get_reward_ad_list(admin_user) {
    return request('post', '/api/snapquiz/get_reward_ad_list', { admin_user })
  },
  get_reward_ad_detail(id) {
    return request('post', '/api/snapquiz/get_reward_ad_detail', { id })
  },
  // payload: { id?, ad_key, title, layout_type, duration_sec, reward_button_text,
  //            allow_early_close, is_active, placement, priority, start_at, end_at, memo, blocks[] }
  save_reward_ad(payload) {
    return request('post', '/api/snapquiz/save_reward_ad', payload)
  },
  delete_reward_ad(id) {
    return request('post', '/api/snapquiz/delete_reward_ad', { id })
  },
  set_reward_ad_active(id, is_active) {
    return request('post', '/api/snapquiz/set_reward_ad_active', { id, is_active })
  },
  get_reward_ad_stats(id, start_date, end_date) {
    return request('post', '/api/snapquiz/get_reward_ad_stats', { id, start_date, end_date })
  },
  get_reward_ad_dashboard(admin_user) {
    return request('post', '/api/snapquiz/get_reward_ad_dashboard', { admin_user })
  },
}

export const servers = {
  get_servers(package_name) {
    return request('post', '/api/get_game_servers', { package_name })
  }
}

// 광고 관련 요청들
export const ad = {
  get_app_info_list(admin_user, selected_ad_os, selected_ad_language) {
    return request('post', '/api/get_appList', { admin_user, selected_ad_os, selected_ad_language })
  },
  // 광고 통계 데이터를 가져온다
  // 매개변수 수정 필요, 폼의 내용들을 보내준다.
  get_statistics_data(admin_user, selected_ad_os, selected_ad_language, app_ad, tempInfo) {
    return request('post', '/api/get_statistics_data', { admin_user, selected_ad_os, selected_ad_language, app_ad, tempInfo })
  },
  // 광고의 우선 노출순위를 수정한다.
  app_ordering(admin_user, selected_ad_os, selected_ad_language, list_for_ordering) {
    return request('post', '/api/app_ordering', { admin_user, selected_ad_os, selected_ad_language, list_for_ordering })
  },
  // 광고의 우선 노출 여부를 수정한다.
  update_use_flag(admin_user, selected_ad_os, selected_ad_language, selected_app_id, app_use_flag) {
    return request('post', '/api/update_use_flag', { admin_user, selected_ad_os, selected_ad_language, selected_app_id, app_use_flag })
  },
  // 광고의 설정정보를 변경시킨다.
  update_ad_config(
    admin_user,
    selected_ad_os,
    selected_ad_language,
    app_id,
    app_front_ad_flag,
    app_main_ad_flag,
    app_mid_ad_flag,
    app_end_ad_flag,
    app_first_order,
    app_repeat_count,
  ) {
    return request('post', '/api/update_ad_config', {
      admin_user,
      selected_ad_os,
      selected_ad_language,
      app_id,
      app_front_ad_flag,
      app_main_ad_flag,
      app_mid_ad_flag,
      app_end_ad_flag,
      app_first_order,
      app_repeat_count,
    })
  },

  // 수정하려는 appId를 가져온다.
  get_app_info(admin_user, selected_ad_os, selected_ad_language, appId) {
    return request('post', '/get_app_info', { admin_user, selected_ad_os, selected_ad_language, appId })
  },

  // 사진을 업로드 또는 삭제하며 데이터베이스에도 반영한다.
  upload_delete_file(admin_user, selected_ad_os, selected_ad_language, appId, fileType, uploadOrDelete, file, fileId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileId', fileId);
    formData.append('admin_user', admin_user);
    formData.append('selected_ad_os', selected_ad_os);
    formData.append('selected_ad_language', selected_ad_language);
    formData.append('appId', appId);
    formData.append('fileType', fileType);
    formData.append('uploadOrDelete', uploadOrDelete);
    return request('post', '/upload_delete_file', formData)
  },

  // 광고 정보를 update 또는 create한다.
  update_create_apps_info(
    admin_user,
    selected_ad_os,
    selected_ad_language,
    appId,
    appName,
    appPackage,
    appAppleId,
    urlSchemes,
    appVersion,
    appCustomLink,
    appCustomUrl,
    appReservation,
    appReservationUrl,
    appNotice,
    appNoticeStartDate,
    appNoticeEndDate,
    appUseFlag,
    appNoticeFileId,
    appIconFileId,
    appGraphicFileId,
    appPortraitFileId,
    appLandscapeFileId
  ) {
    return request('post', '/update_create_apps_info', {
      admin_user,
      selected_ad_os,
      selected_ad_language,
      appId,
      appName,
      appPackage,
      appAppleId,
      urlSchemes,
      appVersion,
      appCustomLink,
      appCustomUrl,
      appReservation,
      appReservationUrl,
      appNotice,
      appNoticeStartDate,
      appNoticeEndDate,
      appUseFlag,
      appNoticeFileId,
      appIconFileId,
      appGraphicFileId,
      appPortraitFileId,
      appLandscapeFileId
    })
  },

}

// 하우스 애드 (House Ad) API — document/HOUSEAD_API_LIST.md 기준
// 응답이 { response_data } 형태면 자동 언래핑
const houseadUnwrap = (res) => (res && res.response_data !== undefined ? res.response_data : res);

export const housead = {
  cmsInit() {
    return request('get', '/api/housead/cms-init').then(houseadUnwrap);
  },
  getApps() {
    return request('get', '/api/housead/apps').then(houseadUnwrap);
  },
  getApp(pid) {
    return request('get', `/api/housead/apps/${pid}`).then(houseadUnwrap);
  },
  createApp(body) {
    return request('post', '/api/housead/apps', body).then(houseadUnwrap);
  },
  updateApp(pid, body) {
    return request('put', `/api/housead/apps/${pid}`, body).then(houseadUnwrap);
  },
  deleteApp(pid) {
    return request('delete', `/api/housead/apps/${pid}`).then(houseadUnwrap);
  },

  // --- 서드파티 연동 (쿠폰 구매 / 전화번호 인증 공용) ---
  // 자격증명 조회 — 시크릿은 HMAC 검증에 원본이 필요해 평문 보관이 불가피하므로
  // 언제든 다시 볼 수 있다. 목록 API 에는 실리지 않고 이 액션에서만 반환된다.
  getAppCredentials(pid) {
    return request('get', `/api/housead/apps/${pid}/credentials`).then(houseadUnwrap);
  },
  // 자격증명 재발급 (기존 시크릿은 즉시 무효 — 앱에도 새 값을 넣어야 함)
  issueAppCredentials(pid) {
    return request('post', `/api/housead/apps/${pid}/credentials`).then(houseadUnwrap);
  },
  // 허용 IP 화이트리스트 (활성 IP 0건이면 해당 앱의 서드파티 호출은 전면 차단)
  getAppAllowIps(pid) {
    return request('get', `/api/housead/apps/${pid}/allow-ips`).then(houseadUnwrap);
  },
  createAppAllowIp(pid, body) {
    return request('post', `/api/housead/apps/${pid}/allow-ips`, body).then(houseadUnwrap);
  },
  deleteAppAllowIp(pid, ipPid) {
    return request('delete', `/api/housead/apps/${pid}/allow-ips/${ipPid}`).then(houseadUnwrap);
  },
  getRewardTypes() {
    return request('get', '/api/housead/reward-types').then(houseadUnwrap);
  },
  getRewardType(pid) {
    return request('get', `/api/housead/reward-types/${pid}`).then(houseadUnwrap);
  },
  createRewardType(body) {
    return request('post', '/api/housead/reward-types', body).then(houseadUnwrap);
  },
  updateRewardType(pid, body) {
    return request('put', `/api/housead/reward-types/${pid}`, body).then(houseadUnwrap);
  },
  deleteRewardType(pid) {
    return request('delete', `/api/housead/reward-types/${pid}`).then(houseadUnwrap);
  },
  getAdConfigs() {
    return request('get', '/api/housead/ad-configs').then(houseadUnwrap);
  },
  getAdConfig(appPid) {
    return request('get', `/api/housead/ad-configs?appPid=${appPid}`).then(houseadUnwrap);
  },
  putAdConfigs(body) {
    return request('put', '/api/housead/ad-configs', body).then(houseadUnwrap);
  },
  getParticipationList(limit) {
    return request('get', `/api/housead/participation?limit=${limit || 100}`).then(houseadUnwrap);
  },
  searchParticipation(search_type, keyword) {
    return request('get', `/api/housead/participation?search_type=${search_type}&keyword=${encodeURIComponent(keyword)}`).then(houseadUnwrap);
  },
  deleteParticipation(pid) {
    return request('delete', `/api/housead/participation/${pid}`).then(houseadUnwrap);
  },
};

// 쿠폰 (다우기술) CMS API — docs/coupon_purchase/README.md, CATALOG_SYNC.md
// 응답 언래핑은 housead 와 동일 규약
export const coupon = {
  // --- 카테고리 (다우 필드는 읽기전용. 표시명/정렬만 편집 가능) ---
  getCategories() {
    return request('get', '/api/cms/coupon/categories').then(houseadUnwrap);
  },
  updateCategory(pid, body) {
    return request('put', `/api/cms/coupon/categories/${pid}`, body).then(houseadUnwrap);
  },

  // --- 상품 (SALE_PRICE / ACTIVE 만 편집 가능. 나머지는 동기화 크론이 관리) ---
  getProducts(params) {
    const q = new URLSearchParams(params || {}).toString();
    return request('get', `/api/cms/coupon/products${q ? '?' + q : ''}`).then(houseadUnwrap);
  },
  updateProduct(pid, body) {
    return request('put', `/api/cms/coupon/products/${pid}`, body).then(houseadUnwrap);
  },

  // --- 플레이스먼트 (노출 세트) ---
  getPlacements() {
    return request('get', '/api/cms/coupon/placements').then(houseadUnwrap);
  },
  createPlacement(body) {
    return request('post', '/api/cms/coupon/placements', body).then(houseadUnwrap);
  },
  // categoryPid 를 주면 그 카테고리의 상품 목록까지 함께 반환
  getPlacementDetail(pid, categoryPid) {
    const q = categoryPid ? `?category_pid=${categoryPid}` : '';
    return request('get', `/api/cms/coupon/placements/${pid}${q}`).then(houseadUnwrap);
  },
  updatePlacement(pid, body) {
    return request('put', `/api/cms/coupon/placements/${pid}`, body).then(houseadUnwrap);
  },
  setPlacementCategory(pid, body) {
    return request('post', `/api/cms/coupon/placements/${pid}/category`, body).then(houseadUnwrap);
  },
  setPlacementProduct(pid, body) {
    return request('post', `/api/cms/coupon/placements/${pid}/product`, body).then(houseadUnwrap);
  },
  // 노출 미리보기 — 현재 설정 그대로 게임서버에 내려갈 상품 리스트(크론 대기 없이 실시간 계산)
  //   → { placement:{PID,CODE,NAME}, count, products:[{category, name, brand, sale_price, face_value, image, ...}] }
  previewPlacement(pid) {
    return request('get', `/api/cms/coupon/placements/${pid}/preview`).then(houseadUnwrap);
  },
  // 플레이스먼트 상품 평면 목록(노출 상위/비활성 하단) — 정렬 편집용
  getPlacementProducts(pid) {
    return request('get', `/api/cms/coupon/placements/${pid}/products`).then(houseadUnwrap);
  },
  // 노출 상품 순서 저장 (상위→하위 PID 배열)
  savePlacementProductOrder(pid, orderedProductPids) {
    return request('post', `/api/cms/coupon/placements/${pid}/product-order`,
      { ordered_product_pids: orderedProductPids }).then(houseadUnwrap);
  },

  // --- 운영 ---
  syncNow() {
    return request('post', '/api/cms/coupon/sync-now').then(houseadUnwrap);
  },
  getOrders(params) {
    const q = new URLSearchParams(params || {}).toString();
    return request('get', `/api/cms/coupon/orders${q ? '?' + q : ''}`).then(houseadUnwrap);
  },
  getOrderStats(params) {
    const q = new URLSearchParams(params || {}).toString();
    return request('get', `/api/cms/coupon/order-stats${q ? '?' + q : ''}`).then(houseadUnwrap);
  },
  // 스토어 대시보드 — 매체별 일일 구매(소비) 집계 (캐시+라이브 폴백)
  //   params: { from_date, to_date }  → { daily:[...], by_media:[...], total:{count,amount} }
  getStoreDashboard(params) {
    const q = new URLSearchParams(params || {}).toString();
    return request('get', `/api/cms/coupon/dashboard${q ? '?' + q : ''}`).then(houseadUnwrap);
  },
  // 주문 취소(다우 폐기) — ISSUED 만 가능. 실패 시 실제 상태로 확정된다.
  cancelOrder(pid) {
    return request('post', `/api/cms/coupon/orders/${pid}/cancel`).then(houseadUnwrap);
  },
  // 주문 상태 갱신 — 다우 실제 상태 조회 후 STATUS 동기화(취소 안 함)
  refreshOrderStatus(pid) {
    return request('post', `/api/cms/coupon/orders/${pid}/refresh`).then(houseadUnwrap);
  },
};

// 전화번호 인증 (메일 회수형) CMS API — docs/phone_auth/README.md §5-3
export const phoneAuth = {
  // 최근 인증요청 목록 (기본 50) + 검색
  //   params: { limit, app_pid, user_key, status, phone_number }
  //   각 행의 postback.needsResend 가 true 면 "인증됐는데 포스트백 못 받은" 건
  getLogs(params) {
    const q = new URLSearchParams(params || {}).toString();
    return request('get', `/api/cms/phone-auth/logs${q ? '?' + q : ''}`)
      .then(houseadUnwrap).then((d) => (d && d.logs) || []);
  },
  getLog(pid) {
    return request('get', `/api/cms/phone-auth/logs/${pid}`)
      .then(houseadUnwrap).then((d) => (d && d.log) || null);
  },
  // 포스트백 강제 재전송 — 큐를 READY 로 되돌리면 3초 워커가 자동 전송
  resendPostback(pid) {
    return request('post', `/api/cms/phone-auth/logs/${pid}/resend-postback`).then(houseadUnwrap);
  },
  // 포스트백 큐 현황 (status 미지정 시 FAILED/DEAD 만)
  getPostbacks(params) {
    const q = new URLSearchParams(params || {}).toString();
    return request('get', `/api/cms/phone-auth/postbacks${q ? '?' + q : ''}`)
      .then(houseadUnwrap).then((d) => (d && d.postbacks) || []);
  },
  retryPostback(pid) {
    return request('post', `/api/cms/phone-auth/postbacks/${pid}/retry`).then(houseadUnwrap);
  },
};

// 결제 관련 요청
export const billing = {
  get_billing_projects(user_id) {
    return request('post', '/api/get_billing_projects', { user_id });
  },
  get_project_billing_statistics_data(admin_user, selected_project, temp_info, temp_info_month) {
    return request('post', '/api/get_project_billing_statistics_data', { admin_user, selected_project, temp_info, temp_info_month });
  },
  get_billing_dash_data(admin_user, project_group, selected_language, day_or_month, temp_info) {
    return request('post', '/get_billing_dash_data', { admin_user, project_group, selected_language, day_or_month, temp_info });
  },
  get_billing_products(admin_user, idx) {
    return request('post', '/api/get_billing_products', { admin_user, idx });
  },
  get_billing_log(admin_user, package_name) {
    return request('post', '/api/get_billing_log', { admin_user, package_name });
  },
  //
  create_billing_project(admin_user, project_group, project_name, package_name, callback_url, kakao_flag, android_open_flag, ios_open_flag) {
    return request('post', '/api/create_billing_project', { admin_user, project_group, project_name, package_name, callback_url, kakao_flag, android_open_flag, ios_open_flag });
  },
  update_billing_project(admin_user, idx, project_group, project_name, package_name, callback_url, kakao_flag, android_open_flag, ios_open_flag) {
    return request('post', '/api/update_billing_project', { admin_user, idx, project_group, project_name, package_name, callback_url, kakao_flag, android_open_flag, ios_open_flag });
  },
  create_billing_product(admin_user, project_idx, product_name, product_id_android, product_id_ios, product_id_onestore, product_type, product_cost, product_give_cash, product_bonus) {
    return request('post', '/api/create_billing_product', { admin_user, project_idx, product_name, product_id_android, product_id_ios, product_id_onestore, product_type, product_cost, product_give_cash, product_bonus });
  },
  update_billing_product(admin_user, seq_no, project_idx, product_name, product_id_android, product_id_ios, product_id_onestore, product_type, product_cost, product_give_cash, product_bonus) {
    return request('post', '/api/update_billing_product', { admin_user, seq_no, project_idx, product_name, product_id_android, product_id_ios, product_id_onestore, product_type, product_cost, product_give_cash, product_bonus });
  },
  delete_billing_log(admin_user, seq_no) {
    return request('post', '/api/delete_billing_log', { admin_user, seq_no });
  },
  user_billing_cost_sum(admin_user, package_name, user_id) {
    return request('post', '/api/user_billing_cost_sum', { admin_user, package_name, user_id });
  }


}
export const cms_managed = {
  get_cms_user_list(user_id) {
    return request('post', '/api/get_cms_user_list', { user_id });
  },
  update_cms_user_level(user_id, { target_id, level }) {
    return request('post', '/api/update_cms_user_level', { user_id, target_id, level });
  },
  delete_cms_user(user_id, { target_id }) {
    return request('post', '/api/delete_cms_user', { user_id, target_id })
  }
}
export const gms = {
  fetch_gms_notice(user_id) {
    return request('post', '/api/get_gms_notice', { user_id })
  },
  update_gms_notice(user_id, gms_notice_info, gms_notice_lang_list) {
    return request('post', '/api/update_gms_notice', { user_id, gms_notice_info, gms_notice_lang_list })
  },
  insert_gms_notice(user_id, gms_notice_info, gms_notice_lang_list) {
    return request('post', '/api/insert_gms_notice', { user_id, gms_notice_info, gms_notice_lang_list })
  },
  delete_gms_notice(user_id, gms_notice_info) {
    return request('post', '/api/delete_gms_notice', { user_id, gms_notice_info })
  },
  // JS 신규 GMS 기능들 20210312
  copy_user_account(user_id, source_server_type, source_cs_code, target_server_type, target_cs_code) {
    return request('post', '/api/copy_user_account', { user_id, source_server_type, source_cs_code, target_server_type, target_cs_code })
  }
}
export const dash_board = {
  get_dashboard_data() {
    return request('post', '/api/get_dashboard_data', {})
  },
  get_dashboard_health_data() {
    return request('post', '/api/get_dashboard_health_data', {})
  },
  get_daily_sales_statistics(admin_user) {
    return request('post', '/api/cpu/get_daily_sales_statistics', { admin_user })
  }
}

export const util_img = {
  insert_util_img_s3(thumb_path) {
    return request('post', '/api/insert_util_img_s3', { thumb_path })
  },
  get_util_img_s3_list(count) {
    return request('post', '/api/get_util_img_s3_list', { count })
  }
}




//****** [CPU 프로젝트 관련 API들] *****************
//#region  [CPU 프로젝트 관련 API들] 
///[유저가 구매한 상품 리스트]
export const cpu_user_buy_products = {
  get_user_buy_products() {
    return request('post', '/api/get_user_buy_products', {})
  }
}
///[유저 정보]
// [포인트 채굴기 - API 테스터] 개발/테스트용
export const cpu_dev = {
  // 특정 유저에게 푸시 발송 (CMS_Back 이 토큰 조회 후 Redis 푸시 풀에 등록 → 크론이 FCM 전송)
  send_push_by_userid(admin_user, user_id, title, message) {
    return request('post', '/api/cpu/send_push_by_userid', { admin_user, USER_ID: user_id, TITLE: title, USER_MESSAGE: message })
  },
  // 오퍼월 테스트 지급 — base_domain(라이브/개발 선택) 으로 샘플 포스트백 전송
  offerwall_test(admin_user, provider, user_id, user_pnt, adv_id, base_domain) {
    return request('post', '/api/cpu/offerwall_test', { admin_user, provider, user_id, user_pnt, adv_id, base_domain })
  },
  // 최근 수집된 adv_id 목록 (스냅오퍼월 테스트용)
  get_recent_adv_ids(admin_user) {
    return request('post', '/api/cpu/get_recent_adv_ids', { admin_user })
  },
}

// [포인트 채굴기 - 토큰 컨텐츠(토큰 경매)] 템플릿/보상/모니터링
export const cpu_auction = {
  // 템플릿
  template_list(only_active) {
    return request('post', '/api/cpu/auction/template/list', { only_active: !!only_active })
  },
  template_save(body) {
    return request('post', '/api/cpu/auction/template/save', body)
  },
  template_state(pid, state) {
    return request('post', '/api/cpu/auction/template/state', { pid, state })
  },
  template_set_chosen_reward(pid, reward_pid) {
    return request('post', '/api/cpu/auction/template/set_chosen_reward', { pid, reward_pid })
  },
  // 보상
  reward_list(template_pid) {
    return request('post', '/api/cpu/auction/reward/list', { template_pid })
  },
  reward_save(body) {
    return request('post', '/api/cpu/auction/reward/save', body)
  },
  reward_delete(pid) {
    return request('post', '/api/cpu/auction/reward/delete', { pid })
  },
  // 모니터링(읽기)
  round_list(body) {
    return request('post', '/api/cpu/auction/round/list', body || {})
  },
  round_detail(game_pid) {
    return request('post', '/api/cpu/auction/round/detail', { game_pid })
  },
  bid_list(body) {
    return request('post', '/api/cpu/auction/bid/list', body || {})
  },
  dispatch_retry(body) {
    return request('post', '/api/cpu/auction/dispatch/retry', body || {})
  },
  // 다우 상품 드롭다운(COUPON 보상 선택) — 선택 시 PRODUCT_CODE + 썸네일 자동채움용
  product_list(q) {
    return request('post', '/api/cpu/auction/product/list', { q: q || '' })
  },
}

export const cpu_user_info = {
  reset_user_phone(admin_user, user_id)//전화번호 초기화('') + db_ops 이력 기록
  {
    return request('post', '/api/cpu/reset_user_phone', { admin_user, user_id })
  },
  ban_user(admin_user, packageName, target_user, exp, exp_info, server_index) {
    return request('post', '/api/cpu/ban_user', { admin_user, packageName, target_user, exp, exp_info, server_index })
  },
  // 수정 필요
  unban_user(admin_user, target_user) {
    return request('post', '/api/cpu/unban_user', { admin_user, target_user })
  },
  get_userlist_recent(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/cpu/get_userlist_recent', { admin_user, count })
  },
  get_userlist_referee(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/cpu/get_userlist_referee', { admin_user, count })
  },
  get_userlist_enjoy_ad(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/cpu/get_userlist_enjoy_ad', { admin_user, count, type })
  },
  get_userlist_have_coin(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/cpu/get_userlist_have_coin', { admin_user, count, type })
  },
  change_user_nick_name(admin_user, user_id, nick)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/cpu/change_user_nick_name', { user_id, nick })
  },
  set_user_phone_number(admin_user, user_id, phone)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/cpu/set_user_phone_number', { user_id, phone })
  },


  get_user_referee_list(admin_user, user_id)//유저 추천인리스트를 가져온다 
  {
    return request('post', '/api/cpu/get_user_referee_list', { user_id })
  },
  get_user_cpu_list(admin_user, user_id)//유저 cpu 채굴기 리스트를 가져온다  
  {
    return request('post', '/api/cpu/get_user_cpu_list', { user_id })
  },
  get_user_planet_list(admin_user, user_id)//유저 행성 버프내역을 가져온다
  {
    return request('post', '/api/cpu/get_user_planet_list', { user_id })
  },
  get_user_cashlog_list(admin_user, user_id)//유저 캐시로그 리스트를 가져온다
  {
    return request('post', '/api/cpu/get_user_cashlog_list', { user_id })
  },
  refund_user_cpu(admin_user, user_id, bonus_log_pid, refund_cash) {
    return request('post', '/api/cpu/refund_user_cpu', { admin_user, user_id, bonus_log_pid, refund_cash })
  },
  set_friend_share_per(admin_user, user_id, friend_share_per) {
    return request('post', '/api/cpu/set_friend_share_per', { admin_user, user_id, friend_share_per })
  },

  // 유저 세스코 (어뷰징 분석) — 백엔드 신규 작업 필요. 계약: .omc/plans/user_sesco_api.md
  get_userlist_sesco(admin_user, min_referees, limit, include_banned) {
    return request('post', '/api/cpu/get_userlist_sesco', { admin_user, min_referees, limit, include_banned })
  },
  get_user_sesco_detail(admin_user, user_id, ip_log_days) {
    return request('post', '/api/cpu/get_user_sesco_detail', { admin_user, user_id, ip_log_days })
  },


  get_search_user_list(admin_user, keyword) {
    return request('post', '/api/cpu/get_search_user_list', { admin_user, keyword })
  },
  get_search_user_adid(admin_user, keyword) {
    return request('post', '/api/cpu/get_search_user_adid', { admin_user, keyword })
  },
  // 전면 이벤트 관리
  create_event(admin_user, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos) {
    return request('post', '/api/cpu/create_event', { admin_user, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos })
  },
  get_event_list(admin_user) {
    return request('post', '/api/cpu/get_event_list', { admin_user })
  },
  get_event(admin_user, pid) {
    return request('post', '/api/cpu/get_event', { admin_user, pid })
  },
  edit_event(admin_user, pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos) {
    return request('post', '/api/cpu/edit_event', { admin_user, pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos })
  },
  get_user_info(admin_user, target_user) {
    return request('post', '/api/cpu/get_user_info', { admin_user, target_user })
  },
  set_user_info_data(admin_user, target_user, data)//유저 정보를 저장한다 
  {
    return request('post', '/api/cpu/set_user_info_data', { admin_user, target_user, data })
  },
  set_review_state_reward(admin_user, user_id) {
    return request('post', '/api/cpu/set_review_state_reward', { admin_user, user_id })
  },
  set_widget_review_state_reward(admin_user, user_id) {
    return request('post', '/api/cpu/set_widget_review_state_reward', { admin_user, user_id })
  },
  // 유져 재화 사용내역 가져오기
  get_goods_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/get_goods_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_chat_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/get_chat_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_search_user_nick(admin_user, packageName, nicklist, server_index) {
    return request('post', '/api/get_search_user_nick', { admin_user, packageName, nicklist, server_index })
  },

}
///[쿠폰] 
export const cpu_coupon = {
  create_coupon(admin_user, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id) {
    return request('post', '/api/cpu/create_coupon', { admin_user, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id })
  },
  get_recent_couponlist(admin_user) {
    return request('post', '/api/cpu/get_recent_couponlist', { admin_user })
  },
  get_coupon_list(admin_user, coupon_pid) {//쿠폰 생성할때 서버에 s3에 저장하는것은 어떨까? 엑셀형태로 바로 다운 받을 수 있도록 
    return request('post', '/api/cpu/get_coupon_list', { admin_user, coupon_pid })
  },
  check_double_coupon_id(admin_user, custom_coupon_id) {
    return request('post', '/api/cpu/check_double_coupon_id', { admin_user, custom_coupon_id })
  }
}
///[우편]
export const cpu_mail = {
  create_mail(admin_user, mail_type, user_id, mail_info, expire_start, expire_end) {
    return request('post', '/api/cpu/create_mail', { admin_user, mail_type, user_id, mail_info, expire_start, expire_end })
  },
  edit_mail(admin_user, mail_no, mail_info, expire_start, expire_end) {
    return request('post', '/api/cpu/edit_mail', { admin_user, mail_no, mail_info, expire_start, expire_end })
  },
  get_mail_list_recent(admin_user) {
    return request('post', '/api/cpu/get_mail_list_recent', { admin_user })
  },

  get_mail_list_target(admin_user, user_id) {
    return request('post', '/api/cpu/get_mail_list_target', { admin_user, user_id })
  },
  create_mail_multi(admin_user, user_list, mail_info, expire_start, expire_end) {
    return request('post', '/api/cpu/create_mail_multi', { admin_user, user_list, mail_info, expire_start, expire_end })
  },
}
///[공지]
export const cpu_notice = {
  create_notice(admin_user, notice_title, notice_message) {
    return request('post', '/api/cpu/create_notice', { admin_user, notice_title, notice_message })
  },
  get_notice_list(admin_user) {
    return request('post', '/api/cpu/get_notice_list', { admin_user })
  },

  set_notice(admin_user, notice_title, notice_message, enable_yn, pid) {
    return request('post', '/api/cpu/set_notice', { admin_user, notice_title, notice_message, enable_yn, pid })
  },
  get_notice(pid) {
    return request('post', '/api/cpu/get_notice', { pid })
  },

}
///[서비스 셋팅]
export const cpu_setting = {
  get_game_setting(admin_user) {
    return request('post', '/api/cpu/get_game_setting', { admin_user })
  },
  get_server_time(admin_user, packageName) {
    return request('post', '/api/get_server_time', { admin_user, packageName })
  },
  set_server_time(admin_user, packageName, serverTime) {
    return request('post', '/api/set_server_time', { admin_user, packageName, serverTime })
  },
  rollback_server_time(admin_user, packageName) {
    return request('post', '/api/rollback_server_time', { admin_user, packageName })
  },
  set_game_setting(admin_user, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name) {
    return request('post', '/api/set_game_setting', { admin_user, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name })
  },
  add_upload_table_info(admin_user, packageName, version, user_id, file_path) {
    return request('post', '/api/add_upload_table_info', { admin_user, packageName, version, user_id, file_path })
  },
  get_upload_table_info(admin_user, packageName) {
    return request('post', '/api/get_upload_table_info', { admin_user, packageName })
  },
  user_kick(admin_user, packageName) {
    return request('post', '/api/user_kick', { admin_user, packageName })
  },
  delete_user_all(packageName) {
    return request('post', '/api/delete_user_all', { packageName })
  },
  delete_user(admin_user, packageName, user_id) {
    return request('post', '/api/delete_user', { admin_user, packageName, user_id })
  },

}
///[이벤트 롤링]
export const cpu_event_rolling = {
  get_event_rolling_list(admin_user, event_type) {
    return request('post', '/api/cpu/get_event_rolling_list', { admin_user, event_type })
  },
  create_event_rolling(admin_user, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type) {
    return request('post', '/api/cpu/create_event_rolling', { admin_user, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type })
  },
  edit_event_rolling(admin_user, pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type) {
    return request('post', '/api/cpu/edit_event_rolling', { admin_user, pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type })
  },
  set_main_banner(admin_user, pid, event_type) {
    return request('post', '/api/cpu/set_main_banner', { admin_user, pid, event_type })
  },
}

///[이벤트 미션 - PUBLIC_EVENT_MISSION]
export const cpu_event_mission = {
  get_event_mission_list(admin_user) {
    return request('post', '/api/cpu/get_event_mission_list', { admin_user })
  },
  get_event_mission(admin_user, pid) {
    return request('post', '/api/cpu/get_event_mission', { admin_user, pid })
  },
  create_event_mission(admin_user, title, thumb, start_dt, end_dt, is_enable, info) {
    return request('post', '/api/cpu/create_event_mission', { admin_user, title, thumb, start_dt, end_dt, is_enable, info })
  },
  edit_event_mission(admin_user, pid, title, thumb, start_dt, end_dt, is_enable, info) {
    return request('post', '/api/cpu/edit_event_mission', { admin_user, pid, title, thumb, start_dt, end_dt, is_enable, info })
  },
}

///[티켓 럭키볼 - PUBLIC_EVENT_TICKET_LUCKYBALL]
export const cpu_event_ticket_luckyball = {
  get_event_ticket_luckyball_list(admin_user) {
    return request('post', '/api/cpu/get_event_ticket_luckyball_list', { admin_user })
  },
  create_event_ticket_luckyball(admin_user, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count) {
    return request('post', '/api/cpu/create_event_ticket_luckyball', { admin_user, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count })
  },
  edit_event_ticket_luckyball(admin_user, pid, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count) {
    return request('post', '/api/cpu/edit_event_ticket_luckyball', { admin_user, pid, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count })
  },
}

///[이벤트 검수 - PUB_REVIEW_VERIFY]
export const cpu_review_verify = {
  get_review_list_not_verify(admin_user, review_type) {
    return request('post', '/api/cpu/get_review_list_not_verify', { admin_user, review_type })
  },
  get_review_list_verify_all(admin_user, review_type) {
    return request('post', '/api/cpu/get_review_list_verify_all', { admin_user, review_type })
  },
  set_review_list_approve(admin_user, pids) {
    return request('post', '/api/cpu/set_review_list_approve', { admin_user, pids })
  },
  set_review_list_refuse(admin_user, pids, rejection_reason) {
    return request('post', '/api/cpu/set_review_list_refuse', { admin_user, pids, rejection_reason })
  },
}

///[퀴즈앤캐시 - 유저 이벤트 검수]
export const quizncash_review_verify = {
  get_review_list_not_verify(admin_user, review_type) {
    return request('post', '/api/quizncash/get_review_list_not_verify', { admin_user, review_type })
  },
  get_review_list_verify_all(admin_user, review_type) {
    return request('post', '/api/quizncash/get_review_list_verify_all', { admin_user, review_type })
  },
  set_review_list_approve(admin_user, pids) {
    return request('post', '/api/quizncash/set_review_list_approve', { admin_user, pids })
  },
  set_review_list_refuse(admin_user, pids, rejection_reason) {
    return request('post', '/api/quizncash/set_review_list_refuse', { admin_user, pids, rejection_reason })
  },
}

//나중에는 플젝별로 필요한 api를 묶도록 한다 
export const cpu = {
  pm2_restart(admin_user) {
    return request('post', '/api/cpu/pm2_restart', { admin_user });
  },
  get_swap_coin_list(admin_user) {
    return request('post', '/api/cpu_get_swap_coin_list', { admin_user });
  },
  create_swap_coin_info(admin_user, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type) {
    return request('post', '/api/cpu_create_swap_coin_info', { admin_user, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type });
  },
  edit_swap_coin_info(admin_user, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state) {
    return request('post', '/api/cpu_edit_swap_coin_info', { admin_user, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state });
  },
  get_coin_order_list(admin_user, count) {
    return request('post', '/api/cpu_get_coin_order_list', { admin_user, count });
  },
  search_coin_order_list(admin_user, user_id) {
    return request('post', '/api/cpu_search_coin_order_list', { user_id });
  },
  edit_coin_order_state(admin_user, pid, process_state, comment) {
    return request('post', '/api/cpu_edit_coin_order_state', { admin_user, pid, process_state, comment });
  },
  get_cash_order_list(admin_user, count) {
    return request('post', '/api/cpu_get_cash_order_list', { admin_user, count });
  },
  search_cash_order_list(admin_user, user_id) {
    return request('post', '/api/cpu_search_cash_order_list', { user_id });
  },
  edit_cash_order_state(admin_user, pid, process_state, comment) {
    return request('post', '/api/cpu_edit_cash_order_state', { admin_user, pid, process_state, comment });
  },
  get_youtube_video_info(admin_user) {
    return request('post', '/api/cpu/get_youtube_video_info', { admin_user });
  },
  regist_youtube_video_info(admin_user, yt_video_id, comment, user_id) {
    return request('post', '/api/cpu/regist_youtube_video_info', { admin_user, yt_video_id, comment, user_id });
  },
  edit_youtube_video_info(admin_user, pid, comment, user_id, activate) {
    return request('post', '/api/cpu/edit_youtube_video_info', { admin_user, pid, comment, user_id, activate });
  },

  get_youtube_report_info(admin_user) {
    return request('post', '/api/cpu/get_youtube_report_info', { admin_user });
  },
  edit_youtube_report_info(admin_user, pid, activate) {
    return request('post', '/api/cpu/edit_youtube_report_info', { admin_user, pid, activate });
  },


}
//#endregion



//****** [ 퀴즈 앤 캐시 프로젝트 관련 API들] **************
//#region [ 퀴즈 앤 캐시 프로젝트 관련 API들]
///[유저가 구매한 상품 리스트]
export const quizncash_user_buy_products = {
  get_user_buy_products() {
    return request('post', '/api/quizncash/get_user_buy_products', {})
  }
}
///[유저 정보]
export const quizncash_user_info = {
  reset_user_phone(admin_user, user_id)//전화번호 초기화('') + db_ops 이력 기록
  {
    return request('post', '/api/quizncash/reset_user_phone', { admin_user, user_id })
  },
  ban_user(admin_user, packageName, target_user, exp, exp_info, server_index) {
    return request('post', '/api/quizncash/ban_user', { admin_user, packageName, target_user, exp, exp_info, server_index })
  },
  // 수정 필요
  unban_user(admin_user, target_user) {
    return request('post', '/api/quizncash/unban_user', { admin_user, target_user })
  },
  get_userlist_recent(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/quizncash/get_userlist_recent', { admin_user, count })
  },
  get_userlist_referee(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/quizncash/get_userlist_referee', { admin_user, count })
  },
  get_userlist_enjoy_ad(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/quizncash/get_userlist_enjoy_ad', { admin_user, count, type })
  },
  get_userlist_have_coin(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/quizncash/get_userlist_have_coin', { admin_user, count, type })
  },
  change_user_nick_name(admin_user, user_id, nick)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/quizncash/change_user_nick_name', { user_id, nick })
  },
  set_user_phone_number(admin_user, user_id, phone)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/quizncash/set_user_phone_number', { user_id, phone })
  },


  get_user_referee_list(admin_user, user_id)//유저 추천인리스트를 가져온다 
  {
    return request('post', '/api/quizncash/get_user_referee_list', { user_id })
  },
  get_user_cpu_list(admin_user, user_id)//유저 cpu 채굴기 리스트를 가져온다  
  {
    return request('post', '/api/quizncash/get_user_cpu_list', { user_id })
  },
  get_user_cashlog_list(admin_user, user_id)//유저 캐시로그 리스트를 가져온다  
  {
    return request('post', '/api/quizncash/get_user_cashlog_list', { user_id })
  },
  refund_user_cpu(admin_user, user_id, bonus_log_pid, refund_cash) {
    return request('post', '/api/quizncash/refund_user_cpu', { admin_user, user_id, bonus_log_pid, refund_cash })
  },


  get_search_user_list(admin_user, keyword) {
    return request('post', '/api/quizncash/get_search_user_list', { admin_user, keyword })
  },
  get_user_info(admin_user, target_user) {
    return request('post', '/api/quizncash/get_user_info', { admin_user, target_user })
  },
  set_user_info_data(admin_user, target_user, data)//유저 정보를 저장한다 
  {
    return request('post', '/api/quizncash/set_user_info_data', { admin_user, target_user, data })
  },
  // 유져 재화 사용내역 가져오기
  get_goods_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/quizncash/get_goods_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_chat_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/quizncash/get_chat_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_search_user_nick(admin_user, packageName, nicklist, server_index) {
    return request('post', '/api/quizncash/get_search_user_nick', { admin_user, packageName, nicklist, server_index })
  },

}
///[쿠폰] 
export const quizncash_coupon = {
  create_coupon(admin_user, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id) {
    return request('post', '/api/quizncash/create_coupon', { admin_user, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id })
  },
  get_recent_couponlist(admin_user) {
    return request('post', '/api/quizncash/get_recent_couponlist', { admin_user })
  },
  get_coupon_list(admin_user, coupon_pid) {//쿠폰 생성할때 서버에 s3에 저장하는것은 어떨까? 엑셀형태로 바로 다운 받을 수 있도록 
    return request('post', '/api/quizncash/get_coupon_list', { admin_user, coupon_pid })
  },
  check_double_coupon_id(admin_user, custom_coupon_id) {
    return request('post', '/api/quizncash/check_double_coupon_id', { admin_user, custom_coupon_id })
  }
}
///[우편]
export const quizncash_mail = {
  create_mail(admin_user, mail_type, user_id, mail_info, expire_start, expire_end) {
    return request('post', '/api/quizncash/create_mail', { admin_user, mail_type, user_id, mail_info, expire_start, expire_end })
  },
  get_mail_list_recent(admin_user) {
    return request('post', '/api/quizncash/get_mail_list_recent', { admin_user })
  },

  get_mail_list_target(admin_user, user_id) {
    return request('post', '/api/quizncash/get_mail_list_target', { admin_user, user_id })
  },
  create_mail_multi(admin_user, user_list, mail_info, expire_start, expire_end) {
    return request('post', '/api/quizncash/create_mail_multi', { admin_user, user_list, mail_info, expire_start, expire_end })
  },
}
///[공지]
export const quizncash_notice = {
  create_notice(admin_user, notice_title, notice_message) {
    return request('post', '/api/quizncash/create_notice', { admin_user, notice_title, notice_message })
  },
  get_notice_list(admin_user) {
    return request('post', '/api/quizncash/get_notice_list', { admin_user })
  },

  set_notice(admin_user, notice_title, notice_message, enable_yn, pid) {
    return request('post', '/api/quizncash/set_notice', { admin_user, notice_title, notice_message, enable_yn, pid })
  },
  get_notice(pid) {
    return request('post', '/api/quizncash/get_notice', { pid })
  },

}
///[서비스 셋팅]
export const quizncash_setting = {
  get_game_setting(admin_user) {
    return request('post', '/api/quizncash/get_game_setting', { admin_user })
  },
  get_server_time(admin_user, packageName) {
    return request('post', '/api/quizncash/get_server_time', { admin_user, packageName })
  },
  set_server_time(admin_user, packageName, serverTime) {
    return request('post', '/api/quizncash/set_server_time', { admin_user, packageName, serverTime })
  },
  rollback_server_time(admin_user, packageName) {
    return request('post', '/api/quizncash/rollback_server_time', { admin_user, packageName })
  },
  set_game_setting(admin_user, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name) {
    return request('post', '/api/quizncash/set_game_setting', { admin_user, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name })
  },
  add_upload_table_info(admin_user, packageName, version, user_id, file_path) {
    return request('post', '/api/quizncash/add_upload_table_info', { admin_user, packageName, version, user_id, file_path })
  },
  get_upload_table_info(admin_user, packageName) {
    return request('post', '/api/quizncash/get_upload_table_info', { admin_user, packageName })
  },
  user_kick(admin_user, packageName) {
    return request('post', '/api/quizncash/user_kick', { admin_user, packageName })
  },
  delete_user_all(packageName) {
    return request('post', '/api/quizncash/delete_user_all', { packageName })
  },
  delete_user(admin_user, packageName, user_id) {
    return request('post', '/api/quizncash/delete_user', { admin_user, packageName, user_id })
  },

}
//나중에는 플젝별로 필요한 api를 묶도록 한다 
export const quizncash = {
  pm2_restart(admin_user) {
    return request('post', '/api/pm2_restart', { admin_user });
  },
  get_swap_coin_list(admin_user) {
    return request('post', '/api/quizncash/cpu_get_swap_coin_list', { admin_user });
  },
  create_swap_coin_info(admin_user, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type) {
    return request('post', '/api/quizncash/cpu_create_swap_coin_info', { admin_user, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type });
  },
  edit_swap_coin_info(admin_user, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state) {
    return request('post', '/api/quizncash/cpu_edit_swap_coin_info', { admin_user, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state });
  },
  get_coin_order_list(admin_user, count) {
    return request('post', '/api/quizncash/cpu_get_coin_order_list', { admin_user, count });
  },
  search_coin_order_list(admin_user, user_id) {
    return request('post', '/api/quizncash/cpu_search_coin_order_list', { user_id });
  },
  edit_coin_order_state(admin_user, pid, process_state, comment) {
    return request('post', '/api/quizncash/cpu_edit_coin_order_state', { admin_user, pid, process_state, comment });
  },
  get_cash_order_list(admin_user, count) {
    return request('post', '/api/quizncash/cpu_get_cash_order_list', { admin_user, count });
  },
  search_cash_order_list(admin_user, user_id) {
    return request('post', '/api/quizncash/cpu_search_cash_order_list', { user_id });
  },
  edit_cash_order_state(admin_user, pid, process_state, comment) {
    return request('post', '/api/quizncash/cpu_edit_cash_order_state', { admin_user, pid, process_state, comment });
  },
  get_youtube_video_info(admin_user) {
    return request('post', '/api/quizncash/get_youtube_video_info', { admin_user });
  },
  regist_youtube_video_info(admin_user, yt_video_id, comment, user_id) {
    return request('post', '/api/quizncash/regist_youtube_video_info', { admin_user, yt_video_id, comment, user_id });
  },
  edit_youtube_video_info(admin_user, pid, comment, user_id, activate) {
    return request('post', '/api/quizncash/edit_youtube_video_info', { admin_user, pid, comment, user_id, activate });
  },

  get_youtube_report_info(admin_user) {
    return request('post', '/api/quizncash/get_youtube_report_info', { admin_user });
  },
  edit_youtube_report_info(admin_user, pid, activate) {
    return request('post', '/api/quizncash/edit_youtube_report_info', { admin_user, pid, activate });
  },
  get_dashboard_data(admin_user) {
    return request('post', '/api/quizncash/get_dashboard_data', { admin_user });
  },
  get_daily_sales_statistics(admin_user) {
    return request('post', '/api/quizncash/get_daily_sales_statistics', { admin_user });
  },

}
///[메인 퀴즈 정보]
export const quizncash_mainquiz = {
  create_main_quiz(admin_user, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable) {
    return request('post', '/api/quizncash/create_main_quiz', { admin_user, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable });
  },
  get_main_quiz_list(admin_user) {
    return request('post', '/api/quizncash/get_main_quiz_list', { admin_user });
  },
  edit_main_quiz(admin_user, pid, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable) {
    return request('post', '/api/quizncash/edit_main_quiz', { admin_user, pid, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable });
  },
}
///[이벤트 롤링]
export const quizncash_event_rolling = {
  get_event_rolling_list(admin_user) {
    return request('post', '/api/quizncash/get_event_rolling_list', { admin_user })
  },
  create_event_rolling(admin_user, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info) {
    return request('post', '/api/quizncash/create_event_rolling', { admin_user, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info })
  },
  edit_event_rolling(admin_user, pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info) {
    return request('post', '/api/quizncash/edit_event_rolling', { admin_user, pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info })
  },
}

// [API 테스터] 퀴즈앤캐시 — 개발/테스트용
export const quizncash_dev = {
  // 유저 아이디로 푸시 발송 (CMS_Back 이 토큰 조회 후 Redis 푸시 풀에 등록 → 크론이 FCM 전송)
  send_push_by_userid(admin_user, user_id, title, message) {
    return request('post', '/api/quizncash/send_push_by_userid', { admin_user, USER_ID: user_id, TITLE: title, USER_MESSAGE: message })
  },
  // 오퍼월 테스트 지급 — base_domain(라이브/개발 선택) 으로 샘플 포스트백 전송
  offerwall_test(admin_user, provider, user_id, user_pnt, adv_id, base_domain) {
    return request('post', '/api/quizncash/offerwall_test', { admin_user, provider, user_id, user_pnt, adv_id, base_domain })
  },
  // 최근 수집된 adv_id 목록 (스냅오퍼월 테스트용)
  get_recent_adv_ids(admin_user) {
    return request('post', '/api/quizncash/get_recent_adv_ids', { admin_user })
  },
}
//#endregion


//****** [프로젝트 무관 안쓰거나 보류되었거나] */
//#region [프로젝트 무관 안쓰거나 보류되었거나]
//****** [사전 예약 통계]   *****/
//#region [사전예약 통계등 ]
export const reports = {
  get_log(log_type, start_date, end_date) {
    return request('post', '/api/get_log', { log_type, start_date, end_date })
  },

  get_log_today(log_type) {
    return request('post', '/api/get_log_today', { log_type })
  },
  get_log_history() {
    return request('post', '/api/get_log_history', {})
  },

  add_log_event(admin_user, packageName, event_name, event_key) {
    return request('post', '/api/add_log_event', { packageName, event_name, event_key, admin_user })
  },
}


export const errorlog_list = {
  get_recent_error_logs(admin_user, packageName) {
    return request('post', '/api/get_recent_error_logs', { admin_user, packageName });
  },
  get_user_error_logs(admin_user, packageName, user_id) {
    return request('post', '/api/get_user_error_logs', { admin_user, packageName, user_id });
  },
}



/// [템플릿 테이블 관리 ]
export const template = {
  get_template_logs(packageName) {
    return request('post', '/api/get_template_logs', { packageName })
  },
  insert_template_log(packageName, user_id, templateVer, comment, file_path, isIOS) {
    return request('post', '/api/insert_template_log', { packageName, user_id, templateVer, comment, file_path, isIOS })
  }
}

export const common =
{
  get_app_list(user_id) {
    return request('post', '/api/resource/app_get_file_list', { user_id })
  },
}

//#endregion

//****** [스냅퀴즈 웹 ] *****/
//#region [ 스냅퀴즈 웹 ]


export const quizinfo =
{
  //퀴즈 번들 만들기 
  create_quiz_bundle(admin_user, category, category_comment, img_path, desc_text, ref_pid) {
    return request('post', '/api/create_quiz_bundle', { admin_user, category, category_comment, img_path, desc_text, ref_pid });

  },
  //return request('post', '/api/create_quiz_bundle', {'test':'test2'}); 
  //퀴즈 번들 리스트 가져오기 
  get_quizbundle_list(admin_user) {
    return request('post', '/api/get_quizbundle_list', { admin_user });
  },

  get_quizbundle_info(pid) {
    return request('post', '/api/get_quizbundle_info', { pid });
  },
  //퀴즈 번들 수정하기 
  edit_quizbundle(admin_user, pid, category, category_comment, level, img_path, desc_text) {
    return request('post', '/api/edit_quizbundle', { admin_user, pid, category, category_comment, level, img_path, desc_text });
  },
  //퀴즈 번들 삭제하기
  delete_quizbundle(admin_user, pid) {
    return request('post', '/api/delete_quizbundle', { admin_user, pid });
  },

  //일단 하나씩 하는걸로 생각하자 
  commit_quizbundle(admin_user, pid, commit_path) {
    return request('post', '/api/commit_quizbundle', { admin_user, pid, commit_path });
  },



  //퀴즈 생성하기 
  create_quiz(admin_user, bundle_pid, correct, answer, img_path, need_ad, hide_type) {
    return request('post', '/api/create_quiz', { admin_user, bundle_pid, correct, answer, img_path, need_ad, hide_type });
  },
  //퀴즈 불러오기 
  get_quizlist(admin_user, bundle_pid) {
    return request('post', '/api/get_quizlist', { admin_user, bundle_pid });
  },
  //퀴즈 불러오기 
  edit_quiz_info(bundle_pid, pid, correct, answer, img_path, need_ad, hide_type) {
    return request('post', '/api/edit_quiz_info', { bundle_pid, pid, correct, answer, img_path, need_ad, hide_type });
  },
  //퀴즈 삭제하기 
  delete_quiz(admin_user, pid, bundle_pid) {
    return request('post', '/api/delete_quiz', { admin_user, pid, bundle_pid });
  },


  //퀴즈그룹들 가져오기 
  get_quiz_group_info(admin_user, pid, bundle_pid) {
    return request('post', '/api/get_quiz_group_info', { admin_user, pid, bundle_pid });
  },
  //퀴즈 그룹 생성하기
  create_quiz_group(admin_user, title, comment, count, quiz_type, quiz_count) {
    return request('post', '/api/create_quiz_group', { admin_user, title, comment, count, quiz_type, quiz_count });
  },
  //퀴즈 그룹 아이템 셋팅하기
  get_quiz_group_iteminfo(admin_user, group_pid) {
    return request('post', '/api/get_quiz_group_iteminfo', { admin_user, group_pid });
  },
  //퀴즈 그룹 아이템
  set_quiz_group_iteminfo(admin_user, group_pid, quiz_items, etc_info, quiz_count) {
    return request('post', '/api/set_quiz_group_iteminfo', { admin_user, group_pid, quiz_items, etc_info, quiz_count });
  },



  //퀴즈 번들 만들기 
  create_test_bundle(regist_user, title, desc_text, img_path_small, img_path_big, participants, category) {
    //regist_user, title , img_path_small ,img_path_big,   participants, category
    return request('post', '/api/create_test_bundle', { regist_user, title, desc_text, img_path_small, img_path_big, participants, category });

  },
  //return request('post', '/api/create_quiz_bundle', {'test':'test2'}); 
  //퀴즈 번들 리스트 가져오기 
  get_testbundle_list(admin_user) {
    return request('post', '/api/get_testbundle_list', { admin_user });
  },

  set_testbundle_main(pid) {
    return request('post', '/api/set_testbundle_main', { pid });
  },
  get_testbundle_main() {
    return request('post', '/api/get_testbundle_main', {});
  },


  //심리테스트 번들정보 가져오기 
  get_testbundle_info(pid) {
    return request('post', '/api/get_testbundle_info', { pid });
  },
  //퀴즈 번들 수정하기 
  edit_testbundle(admin_user, pid, title, desc_text, img_path_small, img_path_big, test_count, is_main, participants, category) {
    return request('post', '/api/edit_testbundle', { admin_user, pid, title, desc_text, img_path_small, img_path_big, test_count, is_main, participants, category });
  },
  //퀴즈 번들 삭제하기
  delete_testbundle(admin_user, pid) {
    return request('post', '/api/delete_testbundle', { admin_user, pid });
  },

  //일단 하나씩 하는걸로 생각하자 
  commit_testbundle(pid, commit_path) {
    return request('post', '/api/commit_testbundle', { pid, commit_path });
  },



  //심리 테스트 생성 
  create_test(admin_user, bundle_pid, test_data, need_ad) {
    return request('post', '/api/create_test', { admin_user, bundle_pid, test_data, need_ad });
  },

  get_test_list(pid) {
    return request('post', '/api/get_test_list', { pid });
  },

  //심리 테스트 삭제
  delete_test(bundle_pid, pid) {
    return request('post', '/api/delete_test', { bundle_pid, pid });
  },
  //심리테스트 삭제 
  edit_test(bundle_pid, pid, test_data, need_ad) {
    return request('post', '/api/edit_test', { bundle_pid, pid, test_data, need_ad });
  },


  get_test_list_result(pid) {
    return request('post', '/api/get_test_list_result', { pid });
  },

  //심리 테스트 결과 생성 
  create_test_result(admin_user, bundle_pid, title, desc, img_path, score_start, score_end) {
    return request('post', '/api/create_test_result', { admin_user, bundle_pid, title, desc, img_path, score_start, score_end });
  },

  //심리 테스트 삭제
  delete_test_result(bundle_pid, pid) {
    return request('post', '/api/delete_test_result', { bundle_pid, pid });
  },
  //심리테스트 삭제 
  edit_test_result(bundle_pid, pid, title, desc, img_path, score_start, score_end) {
    return request('post', '/api/edit_test_result', { bundle_pid, pid, title, desc, img_path, score_start, score_end });
  },


  get_img_quizlist_ad() {
    return request('post', '/api/get_img_quizlist_ad', {});
  },
  get_random_img_quizlist_ad(item_count) {
    return request('post', '/api/get_random_img_quizlist_ad', { item_count });
  },
  create_quizlist_ad(admin_user, title, quiz_data, commit_path) {
    return request('post', '/api/create_quizlist_ad', { admin_user, title, quiz_data, commit_path });
  },
  delete_quizlist_ad(pid) {
    return request('post', '/api/delete_quizlist_ad', { pid });
  },
  update_ad_quiz_state(pid, quiz_state) {
    return request('post', '/api/update_ad_quiz_state', { pid, quiz_state });
  },


  get_partner_info(pid) {
    return request('post', '/api/get_partner_info', { pid });
  },
  get_partner_list() {
    return request('post', '/api/get_partner_list', {});
  },
  create_partner(partner_key, partner_name, desc_text, callback_url, thumb_url, activate) {
    return request('post', '/api/create_partner', { partner_key, partner_name, desc_text, callback_url, thumb_url, activate });
  },
  edit_partner_info(pid, partner_name, desc_text, callback_url, thumb_url) {
    return request('post', '/api/edit_partner_info', { pid, partner_name, desc_text, callback_url, thumb_url });
  },
  get_img_quiz_report(start_dt, end_date) {
    return request('post', '/api/get_img_quiz_report', { start_dt, end_date });
  },
  load_quiz_log_visit_main(item_count) {
    return request('post', '/api/load_quiz_log_visit_main', { item_count });
  },



  create_quiz_template(partner_key, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key) {
    return request('post', '/api/create_quiz_template', { partner_key, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key });
  },
  get_quiz_template_list(partner_key) {
    return request('post', '/api/get_quiz_template_list', { partner_key });
  },
  edit_quiz_template(pid, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key) {
    return request('post', '/api/edit_quiz_template', { pid, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key });
  },

  create_notice(admin_user, notice_title, notice_message) {
    return request('post', '/api/create_notice', { admin_user, notice_title, notice_message })
  },
  get_notice_list(admin_user) {
    return request('post', '/api/get_notice_list', { admin_user })
  },

  set_notice(admin_user, notice_title, notice_message, enable_yn, pid) {
    return request('post', '/api/set_notice', { admin_user, notice_title, notice_message, enable_yn, pid })
  },
  get_notice(pid) {
    return request('post', '/api/get_notice', { pid })
  },

  // 그림 퀴즈 관리
  create_drawing_quiz(admin_user, correct, answer, img_path, activate) {
    return request('post', '/api/create_drawing_quiz', { admin_user, correct, answer, img_path, activate });
  },
  get_drawing_quiz_list() {
    return request('post', '/api/get_drawing_quiz_list', {});
  },
  edit_drawing_quiz(pid, correct, answer, img_path, activate) {
    return request('post', '/api/edit_drawing_quiz', { pid, correct, answer, img_path, activate });
  },
  delete_drawing_quiz(pid) {
    return request('post', '/api/delete_drawing_quiz', { pid });
  },

}
//#endregion



//****** [금나르기 프로젝트 관련 API들] *****************
//#region  [금나르기 프로젝트 관련 API들]

/// [애플 계정이전 CS 복구] APPLE AUTH_ID 스왑 + 매칭
export const carrygold_auth_recover = {
  search(admin_user, phone, nick, user_id) {
    return request('post', '/api/carrygold/auth_recover_search', { admin_user, phone, nick, user_id })
  },
  user_ips(admin_user, user_id) {
    return request('post', '/api/carrygold/auth_recover_user_ips', { admin_user, user_id })
  },
  match_ip(admin_user, user_id) {
    return request('post', '/api/carrygold/auth_recover_match_ip', { admin_user, user_id })
  },
  apply_swap(admin_user, user_id_old, user_id_new, reason) {
    return request('post', '/api/carrygold/auth_recover_apply', { admin_user, user_id_old, user_id_new, reason })
  },
  get_log(admin_user, user_id) {
    return request('post', '/api/carrygold/auth_recover_log', { admin_user, user_id })
  },
}

export const carrygold_user_buy_products = {
  get_user_buy_products() {
    return request('post', '/api/carrygold/get_user_buy_products', {})
  }
}
///[유저 정보]
export const carrygold_user_info = {
  reset_user_phone(admin_user, user_id)//전화번호 초기화('') + db_ops 이력 기록
  {
    return request('post', '/api/carrygold/reset_user_phone', { admin_user, user_id })
  },
  ban_user(admin_user, packageName, target_user, exp, exp_info, server_index) {
    return request('post', '/api/carrygold/ban_user', { admin_user, packageName, target_user, exp, exp_info, server_index })
  },
  // 수정 필요
  unban_user(admin_user, target_user) {
    return request('post', '/api/carrygold/unban_user', { admin_user, target_user })
  },
  get_userlist_recent(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/carrygold/get_userlist_recent', { admin_user, count })
  },
  get_userlist_referee(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/carrygold/get_userlist_referee', { admin_user, count })
  },
  get_userlist_enjoy_ad(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/carrygold/get_userlist_enjoy_ad', { admin_user, count, type })
  },
  get_userlist_have_coin(admin_user, count, type)//보유 골드 기준 유저 리스트
  {
    return request('post', '/api/carrygold/get_userlist_have_coin', { admin_user, count, type })
  },
  get_userlist_have_gem(admin_user, count, type)//보유 보석 기준 유저 리스트
  {
    return request('post', '/api/carrygold/get_userlist_have_gem', { admin_user, count, type })
  },
  get_userlist_have_bp(admin_user, count)//현재 채굴량(CUR_BP) 기준 유저 리스트
  {
    return request('post', '/api/carrygold/get_userlist_have_bp', { admin_user, count })
  },
  set_friend_share_per(admin_user, user_id, friend_share_per)//FRIEND_SHARE_PER 값 변경 (0.01~0.5)
  {
    return request('post', '/api/carrygold/set_friend_share_per', { admin_user, user_id, friend_share_per })
  },
  // 유저 세스코 (어뷰징 분석)
  get_userlist_sesco(admin_user, min_referees, limit, include_banned) {
    return request('post', '/api/carrygold/get_userlist_sesco', { admin_user, min_referees, limit, include_banned })
  },
  get_user_sesco_detail(admin_user, user_id, ip_log_days) {
    return request('post', '/api/carrygold/get_user_sesco_detail', { admin_user, user_id, ip_log_days })
  },
  change_user_nick_name(admin_user, user_id, nick)//유저 닉네임을 변경한다
  {
    return request('post', '/api/carrygold/change_user_nick_name', { user_id, nick })
  },
  set_user_phone_number(admin_user, user_id, phone)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/carrygold/set_user_phone_number', { user_id, phone })
  },


  get_user_referee_list(admin_user, user_id)//유저 추천인리스트를 가져온다 
  {
    return request('post', '/api/carrygold/get_user_referee_list', { user_id })
  },
  get_user_cpu_list(admin_user, user_id)//유저 cpu 채굴기 리스트를 가져온다  
  {
    return request('post', '/api/carrygold/get_user_cpu_list', { user_id })
  },
  get_user_cashlog_list(admin_user, user_id)//유저 캐시로그 리스트를 가져온다  
  {
    return request('post', '/api/carrygold/get_user_cashlog_list', { user_id })
  },
  get_user_gemlog_list(admin_user, user_id, start_dt, end_dt)//유저 보석로그 리스트를 가져온다
  {
    return request('post', '/api/carrygold/get_user_gemlog_list', { user_id, start_dt, end_dt })
  },
  refund_user_cpu(admin_user, user_id, bonus_log_pid, refund_cash) {
    return request('post', '/api/carrygold/refund_user_cpu', { admin_user, user_id, bonus_log_pid, refund_cash })
  },
  refund_gem_log(admin_user, gem_log_pid) {
    return request('post', '/api/carrygold/refund_user_cpu', { admin_user, gem_log_pid })
  },


  get_search_user_list(admin_user, keyword) {
    return request('post', '/api/carrygold/get_search_user_list', { admin_user, keyword })
  },
  get_user_info(admin_user, target_user) {
    return request('post', '/api/carrygold/get_user_info', { admin_user, target_user })
  },
  set_review_state_reward(admin_user, user_id) {
    return request('post', '/api/carrygold/set_review_state_reward', { admin_user, user_id })
  },
  set_user_info_data(admin_user, target_user, data)//유저 정보를 저장한다 
  {
    return request('post', '/api/carrygold/set_user_info_data', { admin_user, target_user, data })
  },
  get_chat_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/get_chat_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_search_user_nick(admin_user, packageName, nicklist, server_index) {
    return request('post', '/api/get_search_user_nick', { admin_user, packageName, nicklist, server_index })
  },
}

// [포인트공장 · 유저 상세] 금털기 carrygold_user_info 복사본 (경로만 /api/pnt_factory)
export const pnt_factory_user_info = {
  reset_user_phone(admin_user, user_id)//전화번호 초기화('') + db_ops 이력 기록
  {
    return request('post', '/api/pnt_factory/reset_user_phone', { admin_user, user_id })
  },
  ban_user(admin_user, packageName, target_user, exp, exp_info, server_index) {
    return request('post', '/api/pnt_factory/ban_user', { admin_user, packageName, target_user, exp, exp_info, server_index })
  },
  // 수정 필요
  unban_user(admin_user, target_user) {
    return request('post', '/api/pnt_factory/unban_user', { admin_user, target_user })
  },
  get_userlist_recent(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/pnt_factory/get_userlist_recent', { admin_user, count })
  },
  get_userlist_referee(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/pnt_factory/get_userlist_referee', { admin_user, count })
  },
  get_userlist_enjoy_ad(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/pnt_factory/get_userlist_enjoy_ad', { admin_user, count, type })
  },
  get_userlist_have_coin(admin_user, count, type)//보유 골드 기준 유저 리스트
  {
    return request('post', '/api/pnt_factory/get_userlist_have_coin', { admin_user, count, type })
  },
  get_userlist_have_gem(admin_user, count, type)//보유 보석 기준 유저 리스트
  {
    return request('post', '/api/pnt_factory/get_userlist_have_gem', { admin_user, count, type })
  },
  get_userlist_have_bp(admin_user, count)//현재 채굴량(CUR_BP) 기준 유저 리스트
  {
    return request('post', '/api/pnt_factory/get_userlist_have_bp', { admin_user, count })
  },
  set_friend_share_per(admin_user, user_id, friend_share_per)//FRIEND_SHARE_PER 값 변경 (0.01~0.5)
  {
    return request('post', '/api/pnt_factory/set_friend_share_per', { admin_user, user_id, friend_share_per })
  },
  // 유저 세스코 (어뷰징 분석)
  get_userlist_sesco(admin_user, min_referees, limit, include_banned) {
    return request('post', '/api/pnt_factory/get_userlist_sesco', { admin_user, min_referees, limit, include_banned })
  },
  get_user_sesco_detail(admin_user, user_id, ip_log_days) {
    return request('post', '/api/pnt_factory/get_user_sesco_detail', { admin_user, user_id, ip_log_days })
  },
  change_user_nick_name(admin_user, user_id, nick)//유저 닉네임을 변경한다
  {
    return request('post', '/api/pnt_factory/change_user_nick_name', { user_id, nick })
  },
  set_user_phone_number(admin_user, user_id, phone)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/pnt_factory/set_user_phone_number', { user_id, phone })
  },


  get_user_referee_list(admin_user, user_id)//유저 추천인리스트를 가져온다 
  {
    return request('post', '/api/pnt_factory/get_user_referee_list', { user_id })
  },
  get_user_cpu_list(admin_user, user_id)//유저 cpu 채굴기 리스트를 가져온다  
  {
    return request('post', '/api/pnt_factory/get_user_cpu_list', { user_id })
  },
  get_user_cashlog_list(admin_user, user_id)//유저 캐시로그 리스트를 가져온다  
  {
    return request('post', '/api/pnt_factory/get_user_cashlog_list', { user_id })
  },
  get_user_gemlog_list(admin_user, user_id, start_dt, end_dt)//유저 보석로그 리스트를 가져온다
  {
    return request('post', '/api/pnt_factory/get_user_gemlog_list', { user_id, start_dt, end_dt })
  },
  refund_user_cpu(admin_user, user_id, bonus_log_pid, refund_cash) {
    return request('post', '/api/pnt_factory/refund_user_cpu', { admin_user, user_id, bonus_log_pid, refund_cash })
  },
  refund_gem_log(admin_user, gem_log_pid) {
    return request('post', '/api/pnt_factory/refund_user_cpu', { admin_user, gem_log_pid })
  },


  get_search_user_list(admin_user, keyword) {
    return request('post', '/api/pnt_factory/get_search_user_list', { admin_user, keyword })
  },
  get_user_info(admin_user, target_user) {
    return request('post', '/api/pnt_factory/get_user_info', { admin_user, target_user })
  },
  set_review_state_reward(admin_user, user_id) {
    return request('post', '/api/pnt_factory/set_review_state_reward', { admin_user, user_id })
  },
  set_user_info_data(admin_user, target_user, data)//유저 정보를 저장한다 
  {
    return request('post', '/api/pnt_factory/set_user_info_data', { admin_user, target_user, data })
  },
  get_chat_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/get_chat_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_search_user_nick(admin_user, packageName, nicklist, server_index) {
    return request('post', '/api/get_search_user_nick', { admin_user, packageName, nicklist, server_index })
  },
}

// [돈만농 · 유저 상세] 금털기 carrygold_user_info 복사본 (경로만 /api/mandoora)
export const mandoora_user_info = {
  reset_user_phone(admin_user, user_id)//전화번호 초기화('') + db_ops 이력 기록
  {
    return request('post', '/api/mandoora/reset_user_phone', { admin_user, user_id })
  },
  ban_user(admin_user, packageName, target_user, exp, exp_info, server_index) {
    return request('post', '/api/mandoora/ban_user', { admin_user, packageName, target_user, exp, exp_info, server_index })
  },
  // 수정 필요
  unban_user(admin_user, target_user) {
    return request('post', '/api/mandoora/unban_user', { admin_user, target_user })
  },
  get_userlist_recent(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/mandoora/get_userlist_recent', { admin_user, count })
  },
  get_userlist_referee(admin_user, count)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/mandoora/get_userlist_referee', { admin_user, count })
  },
  get_userlist_enjoy_ad(admin_user, count, type)//최근가입한 유저 리스트를 가져온다 
  {
    return request('post', '/api/mandoora/get_userlist_enjoy_ad', { admin_user, count, type })
  },
  get_userlist_have_coin(admin_user, count, type)//보유 골드 기준 유저 리스트
  {
    return request('post', '/api/mandoora/get_userlist_have_coin', { admin_user, count, type })
  },
  get_userlist_have_gem(admin_user, count, type)//보유 보석 기준 유저 리스트
  {
    return request('post', '/api/mandoora/get_userlist_have_gem', { admin_user, count, type })
  },
  get_userlist_have_bp(admin_user, count)//현재 채굴량(CUR_BP) 기준 유저 리스트
  {
    return request('post', '/api/mandoora/get_userlist_have_bp', { admin_user, count })
  },
  set_friend_share_per(admin_user, user_id, friend_share_per)//FRIEND_SHARE_PER 값 변경 (0.01~0.5)
  {
    return request('post', '/api/mandoora/set_friend_share_per', { admin_user, user_id, friend_share_per })
  },
  // 유저 세스코 (어뷰징 분석)
  get_userlist_sesco(admin_user, min_referees, limit, include_banned) {
    return request('post', '/api/mandoora/get_userlist_sesco', { admin_user, min_referees, limit, include_banned })
  },
  get_user_sesco_detail(admin_user, user_id, ip_log_days) {
    return request('post', '/api/mandoora/get_user_sesco_detail', { admin_user, user_id, ip_log_days })
  },
  change_user_nick_name(admin_user, user_id, nick)//유저 닉네임을 변경한다
  {
    return request('post', '/api/mandoora/change_user_nick_name', { user_id, nick })
  },
  set_user_phone_number(admin_user, user_id, phone)//유저 닉네임을 변경한다 
  {
    return request('post', '/api/mandoora/set_user_phone_number', { user_id, phone })
  },


  get_user_referee_list(admin_user, user_id)//유저 추천인리스트를 가져온다 
  {
    return request('post', '/api/mandoora/get_user_referee_list', { user_id })
  },
  get_user_cpu_list(admin_user, user_id)//유저 cpu 채굴기 리스트를 가져온다  
  {
    return request('post', '/api/mandoora/get_user_cpu_list', { user_id })
  },
  get_user_cashlog_list(admin_user, user_id)//유저 캐시로그 리스트를 가져온다  
  {
    return request('post', '/api/mandoora/get_user_cashlog_list', { user_id })
  },
  get_user_gemlog_list(admin_user, user_id, start_dt, end_dt)//유저 보석로그 리스트를 가져온다
  {
    return request('post', '/api/mandoora/get_user_gemlog_list', { user_id, start_dt, end_dt })
  },
  refund_user_cpu(admin_user, user_id, bonus_log_pid, refund_cash) {
    return request('post', '/api/mandoora/refund_user_cpu', { admin_user, user_id, bonus_log_pid, refund_cash })
  },
  refund_gem_log(admin_user, gem_log_pid) {
    return request('post', '/api/mandoora/refund_user_cpu', { admin_user, gem_log_pid })
  },


  get_search_user_list(admin_user, keyword) {
    return request('post', '/api/mandoora/get_search_user_list', { admin_user, keyword })
  },
  get_user_info(admin_user, target_user) {
    return request('post', '/api/mandoora/get_user_info', { admin_user, target_user })
  },
  set_review_state_reward(admin_user, user_id) {
    return request('post', '/api/mandoora/set_review_state_reward', { admin_user, user_id })
  },
  set_user_info_data(admin_user, target_user, data)//유저 정보를 저장한다 
  {
    return request('post', '/api/mandoora/set_user_info_data', { admin_user, target_user, data })
  },
  get_chat_log_data(admin_user, packageName, target_user, start_date, end_date, server_index)//유저 정보를 저장한다 
  {
    return request('post', '/api/get_chat_log_data', { admin_user, packageName, target_user, start_date, end_date, server_index })
  },
  get_search_user_nick(admin_user, packageName, nicklist, server_index) {
    return request('post', '/api/get_search_user_nick', { admin_user, packageName, nicklist, server_index })
  },
}
///[전면 이벤트 관리 — PUBLIC_EVENT_NOTI]
export const carrygold_event = {
  create_event(admin_user, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos) {
    return request('post', '/api/carrygold/create_event', { admin_user, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos })
  },
  get_event_list(admin_user) {
    return request('post', '/api/carrygold/get_event_list', { admin_user })
  },
  get_event(admin_user, pid) {
    return request('post', '/api/carrygold/get_event', { admin_user, pid })
  },
  edit_event(admin_user, pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos) {
    return request('post', '/api/carrygold/edit_event', { admin_user, pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos })
  },
}
///[쿠폰]
export const carrygold_coupon = {
  create_coupon(admin_user, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id) {
    return request('post', '/api/carrygold/create_coupon', { admin_user, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id })
  },
  get_recent_couponlist(admin_user) {
    return request('post', '/api/carrygold/get_recent_couponlist', { admin_user })
  },
  get_coupon_list(admin_user, coupon_pid) {//쿠폰 생성할때 서버에 s3에 저장하는것은 어떨까? 엑셀형태로 바로 다운 받을 수 있도록 
    return request('post', '/api/carrygold/get_coupon_list', { admin_user, coupon_pid })
  },
  check_double_coupon_id(admin_user, custom_coupon_id) {
    return request('post', '/api/carrygold/check_double_coupon_id', { admin_user, custom_coupon_id })
  }
}
///[우편]
export const carrygold_mail = {
  create_mail(admin_user, mail_type, user_id, mail_info, expire_start, expire_end) {
    return request('post', '/api/carrygold/create_mail', { admin_user, mail_type, user_id, mail_info, expire_start, expire_end })
  },
  edit_mail(admin_user, mail_no, mail_info, expire_start, expire_end) {
    return request('post', '/api/carrygold/edit_mail', { admin_user, mail_no, mail_info, expire_start, expire_end })
  },
  get_mail_list_recent(admin_user) {
    return request('post', '/api/carrygold/get_mail_list_recent', { admin_user })
  },

  get_mail_list_target(admin_user, user_id) {
    return request('post', '/api/carrygold/get_mail_list_target', { admin_user, user_id })
  },
  create_mail_multi(admin_user, user_list, mail_info, expire_start, expire_end) {
    return request('post', '/api/carrygold/create_mail_multi', { admin_user, user_list, mail_info, expire_start, expire_end })
  },
}
///[공지]
export const carrygold_notice = {
  create_notice(admin_user, notice_title, notice_message) {
    return request('post', '/api/carrygold/create_notice', { admin_user, notice_title, notice_message })
  },
  get_notice_list(admin_user) {
    return request('post', '/api/carrygold/get_notice_list', { admin_user })
  },

  set_notice(admin_user, notice_title, notice_message, enable_yn, pid) {
    return request('post', '/api/carrygold/set_notice', { admin_user, notice_title, notice_message, enable_yn, pid })
  },
  get_notice(pid) {
    return request('post', '/api/carrygold/get_notice', { pid })
  },
  get_notice_list_not_verify(admin_user, review_type) {
    return request('post', '/api/carrygold_get_notice_list_not_verify', { admin_user, review_type });
  },
  get_notice_list_verify_all(admin_user, review_type) {
    return request('post', '/api/carrygold_get_notice_list_verify_all', { admin_user, review_type });
  },
  // review_type(GOLD|MARKET) 필수 — 금리뷰/마켓리뷰가 서로 다른 테이블이라 대상 확정에 필요
  set_notice_list_approve(admin_user, pids, review_type) {
    return request('post', '/api/carrygold_set_notice_list_approve', { admin_user, pids, review_type });
  },
  set_notice_list_refuse(admin_user, pids, rejection_reason, review_type) {
    return request('post', '/api/carrygold_set_notice_list_refuse', { admin_user, pids, rejection_reason, review_type });
  },
  create_notice_verify(USER_ID, IMAGE, TITLE, MESSAGE, PRODUCT_PID, NOTICE_TYPE, ENABLE_REPLY, REVIEW_TYPE) {
    return request('post', '/api/carrygold_create_notice_verify', { USER_ID, IMAGE, TITLE, MESSAGE, PRODUCT_PID, NOTICE_TYPE, ENABLE_REPLY, REVIEW_TYPE });
  },
}
///[서비스 셋팅]
export const carrygold_setting = {

}
///[개발 유틸리티]
export const carrygold_dev = {
  send_realtime_notification(admin_user, user_id, msg_tag, user_message) {
    return request('post', '/api/carrygold/send_realtime_notification', { USER_ID: user_id, MSG_TAG: msg_tag, USER_MESSAGE: user_message })
  },
  send_push_test(admin_user, push_token, user_message, title, user_id) {
    return request('post', '/api/carrygold/send_push_test', { PUSH_TOKEN: push_token, USER_MESSAGE: user_message, TITLE: title, USER_ID: user_id })
  },
  offerwall_receive_snapplay(admin_user, pub_user_nm, user_pnt) {
    return request('post', '/api/carrygold/offerwall_receive_snapplay', { pub_user_nm: pub_user_nm, user_pnt: user_pnt })
  },
  // 금털기 지원 전 오퍼월 샘플 포스트백 테스트 (provider 선택)
  // 유저 아이디로 푸시 발송 (CMS_Back 이 토큰 조회 후 Redis 푸시 풀에 등록 → 크론이 FCM 전송)
  send_push_by_userid(admin_user, user_id, title, message) {
    return request('post', '/api/carrygold/send_push_by_userid', { admin_user, USER_ID: user_id, TITLE: title, USER_MESSAGE: message })
  },
  // base_domain 을 주면 그 도메인으로 포스트백 전송(라이브/개발 선택). 없으면 서버 기본값.
  offerwall_test(admin_user, provider, user_id, user_pnt, adv_id, base_domain) {
    return request('post', '/api/carrygold/offerwall_test', { provider, user_id, user_pnt, adv_id, base_domain })
  },
  // 최근 수집된 adv_id 목록 (스냅오퍼월 테스트용)
  get_recent_adv_ids(admin_user) {
    return request('post', '/api/carrygold/get_recent_adv_ids', { admin_user })
  },
  receive_snapplay_review_event(admin_user, attr_id, actn_cd) {
    return request('post', '/api/carrygold/receive_snapplay_review_event', { attr_id: attr_id, actn_cd: actn_cd })
  },
  dev_give_point(admin_user, user_id, amount, reason) {
    return request('post', '/api/carrygold/dev_give_point', { admin_user, user_id, amount, reason })
  },
  dev_roulette_join(admin_user, user_id, round_pid, bet_gold, bet_tag) {
    return request('post', '/api/carrygold/dev_roulette_join', { admin_user, user_id, round_pid, bet_gold, bet_tag })
  },
}

// [포인트공장 · 개발 유틸리티] 금털기 carrygold_dev 복사본 (경로만 /api/pnt_factory, 룰렛 제외)
export const pnt_factory_dev = {
  send_realtime_notification(admin_user, user_id, msg_tag, user_message) {
    return request('post', '/api/pnt_factory/send_realtime_notification', { USER_ID: user_id, MSG_TAG: msg_tag, USER_MESSAGE: user_message })
  },
  send_push_test(admin_user, push_token, user_message, title, user_id) {
    return request('post', '/api/pnt_factory/send_push_test', { PUSH_TOKEN: push_token, USER_MESSAGE: user_message, TITLE: title, USER_ID: user_id })
  },
  offerwall_receive_snapplay(admin_user, pub_user_nm, user_pnt) {
    return request('post', '/api/pnt_factory/offerwall_receive_snapplay', { pub_user_nm: pub_user_nm, user_pnt: user_pnt })
  },
  offerwall_test(admin_user, provider, user_id, user_pnt, adv_id, base_domain) {
    return request('post', '/api/pnt_factory/offerwall_test', { provider, user_id, user_pnt, adv_id, base_domain })
  },
  get_recent_adv_ids(admin_user) {
    return request('post', '/api/pnt_factory/get_recent_adv_ids', { admin_user })
  },
  receive_snapplay_review_event(admin_user, attr_id, actn_cd) {
    return request('post', '/api/pnt_factory/receive_snapplay_review_event', { attr_id: attr_id, actn_cd: actn_cd })
  },
  dev_give_point(admin_user, user_id, amount, reason) {
    return request('post', '/api/pnt_factory/dev_give_point', { admin_user, user_id, amount, reason })
  },
}

// [돈만농 · 개발 유틸리티] 금털기 carrygold_dev 복사본 (경로만 /api/mandoora, 룰렛 제외)
export const mandoora_dev = {
  send_realtime_notification(admin_user, user_id, msg_tag, user_message) {
    return request('post', '/api/mandoora/send_realtime_notification', { USER_ID: user_id, MSG_TAG: msg_tag, USER_MESSAGE: user_message })
  },
  send_push_test(admin_user, push_token, user_message, title, user_id) {
    return request('post', '/api/mandoora/send_push_test', { PUSH_TOKEN: push_token, USER_MESSAGE: user_message, TITLE: title, USER_ID: user_id })
  },
  offerwall_receive_snapplay(admin_user, pub_user_nm, user_pnt) {
    return request('post', '/api/mandoora/offerwall_receive_snapplay', { pub_user_nm: pub_user_nm, user_pnt: user_pnt })
  },
  offerwall_test(admin_user, provider, user_id, user_pnt, adv_id, base_domain) {
    return request('post', '/api/mandoora/offerwall_test', { provider, user_id, user_pnt, adv_id, base_domain })
  },
  get_recent_adv_ids(admin_user) {
    return request('post', '/api/mandoora/get_recent_adv_ids', { admin_user })
  },
  receive_snapplay_review_event(admin_user, attr_id, actn_cd) {
    return request('post', '/api/mandoora/receive_snapplay_review_event', { attr_id: attr_id, actn_cd: actn_cd })
  },
  dev_give_point(admin_user, user_id, amount, reason) {
    return request('post', '/api/mandoora/dev_give_point', { admin_user, user_id, amount, reason })
  },
}
//나중에는 플젝별로 필요한 api를 묶도록 한다 
export const carrygold = {
  pm2_restart(admin_user) {
    return request('post', '/api/carrygold/pm2_restart', { admin_user });
  },
  get_swap_coin_list(admin_user) {
    return request('post', '/api/carrygold_get_swap_coin_list', { admin_user });
  },
  create_swap_coin_info(admin_user, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type) {
    return request('post', '/api/carrygold_create_swap_coin_info', { admin_user, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type });
  },
  edit_swap_coin_info(admin_user, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state) {
    return request('post', '/api/carrygold_edit_swap_coin_info', { admin_user, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state });
  },
  get_coin_order_list(admin_user, count) {
    return request('post', '/api/carrygold_get_coin_order_list', { admin_user, count });
  },
  search_coin_order_list(admin_user, user_id) {
    return request('post', '/api/carrygold_search_coin_order_list', { user_id });
  },
  edit_coin_order_state(admin_user, pid, process_state, comment) {
    return request('post', '/api/carrygold_edit_coin_order_state', { admin_user, pid, process_state, comment });
  },
  get_cash_order_list(admin_user, count) {
    return request('post', '/api/carrygold_get_cash_order_list', { admin_user, count });
  },
  search_cash_order_list(admin_user, user_id) {
    return request('post', '/api/carrygold_search_cash_order_list', { user_id });
  },
  edit_cash_order_state(admin_user, pid, process_state, comment) {
    return request('post', '/api/carrygold_edit_cash_order_state', { admin_user, pid, process_state, comment });
  },
  get_gold_order_list(admin_user, count) {
    return request('post', '/api/carrygold_get_gold_order_list', { admin_user, count });
  },
  search_gold_order_list(admin_user, user_id) {
    return request('post', '/api/carrygold_search_gold_order_list', { user_id });
  },
  // delivery_company / tracking_no : 배송중 처리 시 배송사·송장번호 (일괄 상태변경은 미전송 → undefined 는 전송되지 않음)
  edit_gold_order_state(admin_user, pid, process_state, comment, delivery_company, tracking_no) {
    return request('post', '/api/carrygold_edit_gold_order_state', { admin_user, pid, process_state, comment, delivery_company, tracking_no });
  },
  get_youtube_video_info(admin_user) {
    return request('post', '/api/carrygold/get_youtube_video_info', { admin_user });
  },
  regist_youtube_video_info(admin_user, yt_video_id, comment, user_id) {
    return request('post', '/api/carrygold/regist_youtube_video_info', { admin_user, yt_video_id, comment, user_id });
  },
  edit_youtube_video_info(admin_user, pid, comment, user_id, activate) {
    return request('post', '/api/carrygold/edit_youtube_video_info', { admin_user, pid, comment, user_id, activate });
  },

  get_youtube_report_info(admin_user) {
    return request('post', '/api/carrygold/get_youtube_report_info', { admin_user });
  },
  edit_youtube_report_info(admin_user, pid, activate) {
    return request('post', '/api/carrygold/edit_youtube_report_info', { admin_user, pid, activate });
  },
  get_dashboard_data(admin_user) {
    return request('post', '/api/carrygold/get_dashboard_data', { admin_user });
  },
  get_daily_sales_statistics(admin_user) {
    return request('post', '/api/carrygold/get_daily_sales_statistics', { admin_user });
  },
  get_gold_price() {
    return request('post', '/api/carrygold/get_gold_price', {});
  },
  get_client_log_list(admin_user, count, user_id) {
    return request('post', '/api/carrygold/get_client_log_list', { admin_user, count, user_id });
  },
}

///[단타의 신]
export const danta_client = {
  get_client_list(admin_user) {
    return request('post', '/api/danta_get_client_list', { admin_user });
  },
  create_client(admin_user, data) {
    return request('post', '/api/danta_create_client', { admin_user, ...data });
  },
  update_client(admin_user, data) {
    return request('post', '/api/danta_update_client', { admin_user, ...data });
  },
  delete_client(admin_user, client_id) {
    return request('post', '/api/danta_delete_client', { admin_user, client_id });
  },
  get_client_user_list(admin_user, client_id) {
    return request('post', '/api/danta_get_client_user_list', { admin_user, client_id });
  },
  save_client_users(admin_user, client_id, users) {
    return request('post', '/api/danta_save_client_users', { admin_user, client_id, users });
  },
  get_client_contact_list(admin_user, client_id) {
    return request('post', '/api/danta_get_client_contact_list', { admin_user, client_id });
  },
  save_client_contacts(admin_user, client_id, contacts) {
    return request('post', '/api/danta_save_client_contacts', { admin_user, client_id, contacts });
  },
}

export const danta_media = {
  get_media_list(admin_user, client_id) {
    return request('post', '/api/danta_get_media_list', { admin_user, client_id });
  },
  create_media(admin_user, data) {
    return request('post', '/api/danta_create_media', { admin_user, ...data });
  },
  update_media(admin_user, data) {
    return request('post', '/api/danta_update_media', { admin_user, ...data });
  },
  delete_media(admin_user, media_id) {
    return request('post', '/api/danta_delete_media', { admin_user, media_id });
  },
}

export const danta_user = {
  search_user(admin_user, filter) {
    return request('post', '/api/danta_search_user', { admin_user, ...filter });
  },
  get_user_detail(admin_user, client_id, app_key, user_id) {
    return request('post', '/api/danta_get_user_detail', { admin_user, client_id, app_key, user_id });
  },
  get_user_by_unique_key(admin_user, unique_key) {
    return request('post', '/api/danta_get_user_by_unique_key', { admin_user, unique_key });
  },
  ban_user(admin_user, client_id, app_key, user_id, status) {
    return request('post', '/api/danta_ban_user', { admin_user, client_id, app_key, user_id, status });
  },
  get_user_count(admin_user, client_id, app_key) {
    return request('post', '/api/danta_get_user_count', { admin_user, client_id, app_key });
  },
}

export const danta_game_template = {
  get_list(admin_user) {
    return request('post', '/api/danta_get_game_template_list', { admin_user });
  },
  create(admin_user, data) {
    return request('post', '/api/danta_create_game_template', { admin_user, ...data });
  },
  update(admin_user, data) {
    return request('post', '/api/danta_update_game_template', { admin_user, ...data });
  },
}

export const danta_game = {
  get_list(admin_user, status, template_id, symbol, page, page_size) {
    return request('post', '/api/danta_get_game_list', { admin_user, status, template_id, symbol, page, page_size });
  },
  get_detail(admin_user, game_id) {
    return request('post', '/api/danta_get_game_detail', { admin_user, game_id });
  },
  create(admin_user, data) {
    return request('post', '/api/danta_create_game', { admin_user, ...data });
  },
  update_status(admin_user, game_id, status) {
    return request('post', '/api/danta_update_game_status', { admin_user, game_id, status });
  },
  // 게임 메타 / 운영 파라미터 / margin 수정 — { game_id, title?, margin?, round_duration?, bet_cutoff?, schedule_type?, bet_amount?, ... }
  update(admin_user, data) {
    return request('post', '/api/danta_update_game', { admin_user, ...data });
  },
}

// sports/quiz 단발 게임 + choice_groups
// 선택지 그룹 (가격형/sports 자동화 모두 공통)
export const danta_choice_group = {
  get_list(admin_user, { category } = {}) {
    return request('post', '/api/danta_get_choice_groups', { admin_user, category });
  },
  create(admin_user, data) {
    return request('post', '/api/danta_create_choice_group', { admin_user, ...data });
  },
}

// manual 운영 (퀴즈/정치/이벤트) — 운영자가 라운드 단위 등록/마감/결과
export const danta_manual_round = {
  create(admin_user, data) {
    return request('post', '/api/danta_manual_round_create', { admin_user, ...data });
  },
  close(admin_user, round_id) {
    return request('post', '/api/danta_manual_round_close', { admin_user, round_id });
  },
  set_result(admin_user, { round_id, choice_code, result_meta, reason }) {
    return request('post', '/api/danta_manual_round_result', { admin_user, round_id, choice_code, result_meta, reason });
  },
  cancel(admin_user, { round_id, reason }) {
    return request('post', '/api/danta_manual_round_cancel', { admin_user, round_id, reason });
  },
  list(admin_user, { game_id, limit } = {}) {
    return request('post', '/api/danta_manual_rounds_list', { admin_user, game_id, limit });
  },
}

// DEV 전용 — 임의 결과로 라운드 강제 정산 (테스트용. live 에서는 DT 가 404 차단)
export const danta_only_dev_api = {
  get_round_info(admin_user, round_id) {
    return request('post', '/api/danta_dev_round_info', { admin_user, round_id });
  },
  force_result(admin_user, { round_id, choice_code, reason, skip_callback }) {
    return request('post', '/api/danta_dev_force_result', { admin_user, round_id, choice_code, reason, skip_callback });
  },
}

// 매체사 콜백 모니터링 — list / stats / circuit / retry
export const danta_callback = {
  get_list(admin_user, { status, event_type, app_key, page, page_size } = {}) {
    return request('post', '/api/danta_callback_list', { admin_user, status, event_type, app_key, page, page_size });
  },
  get_stats(admin_user) {
    return request('post', '/api/danta_callback_stats', { admin_user });
  },
  get_circuit(admin_user) {
    return request('post', '/api/danta_callback_circuit', { admin_user });
  },
  retry(admin_user, ids) {
    return request('post', '/api/danta_callback_retry', { admin_user, ids });
  },
}

export const danta_game_round = {
  get_list(admin_user, game_id, status, page, page_size) {
    return request('post', '/api/danta_get_game_round_list', { admin_user, game_id, status, page, page_size });
  },
  get_detail(admin_user, round_id) {
    return request('post', '/api/danta_get_game_round_detail', { admin_user, round_id });
  },
  get_round_bets(admin_user, params) {
    return request('post', '/api/danta_get_round_bets', { admin_user, ...params });
  },
}

export const danta_setting = {
  get_noti_server_list(admin_user) {
    return request('post', '/api/danta_get_noti_server_list', { admin_user });
  },
  create_noti_server(admin_user, data) {
    return request('post', '/api/danta_create_noti_server', { admin_user, ...data });
  },
  update_noti_server(admin_user, data) {
    return request('post', '/api/danta_update_noti_server', { admin_user, ...data });
  },
  delete_noti_server(admin_user, server_id) {
    return request('post', '/api/danta_delete_noti_server', { admin_user, server_id });
  },
}

export const danta_dashboard = {
  get_dashboard(admin_user) {
    return request('post', '/api/danta_get_dashboard', { admin_user });
  },
  get_broadcast_servers(admin_user) {
    return request('post', '/api/danta_get_broadcast_servers', { admin_user });
  },
}

export const danta_debug = {
  run_bet_test(admin_user, data) {
    return request('post', '/api/danta_run_bet_test', { admin_user, ...data });
  },
  // 진행중 라운드 단건 — { game_id }
  get_current_round(admin_user, game_id) {
    return request('post', '/api/danta_get_current_round', { admin_user, game_id });
  },
  // 라운드 강제 무효 — { round_id, reason? }
  cancel_round(admin_user, round_id, reason) {
    return request('post', '/api/danta_cancel_round', { admin_user, round_id, reason });
  },
  // bet_orders 조회 — filters: { game_id?, round_id?, status?, app_key?, user_id?, since?, limit? }
  get_bet_orders(admin_user, filters) {
    return request('post', '/api/danta_get_bet_orders', { admin_user, ...(filters || {}) });
  },
  // 특정 order_id 의 콜백 시도 이력
  get_bet_order_attempts(admin_user, order_id) {
    return request('post', '/api/danta_get_bet_order_attempts', { admin_user, order_id });
  },
}

// 통계 / 정산 — Service_DT_Back /api/admin/stats/* 프록시
export const danta_stats = {
  // 오늘 전체 요약 (10s 캐시)
  today_summary(admin_user) {
    return request('post', '/api/danta_stats_today_summary', { admin_user });
  },
  // 오늘 매체별 (top N)
  today_by_media(admin_user, limit) {
    return request('post', '/api/danta_stats_today_by_media', { admin_user, limit });
  },
  // 오늘 게임별 (top N)
  today_by_game(admin_user, limit) {
    return request('post', '/api/danta_stats_today_by_game', { admin_user, limit });
  },
  // 일별 매체 — { from, to?, client_id?, app_key?, media_id? }
  daily_media(admin_user, filters) {
    return request('post', '/api/danta_stats_daily_media', { admin_user, ...(filters || {}) });
  },
  // 일별 게임 — { from, to?, game_id? }
  daily_games(admin_user, filters) {
    return request('post', '/api/danta_stats_daily_games', { admin_user, ...(filters || {}) });
  },
  // 월별 매체 — { from, to?, client_id?, app_key?, media_id? }
  monthly_media(admin_user, filters) {
    return request('post', '/api/danta_stats_monthly_media', { admin_user, ...(filters || {}) });
  },
  // 월별 게임 — { from, to?, game_id? }
  monthly_games(admin_user, filters) {
    return request('post', '/api/danta_stats_monthly_games', { admin_user, ...(filters || {}) });
  },
  // cron 상태
  cron_status(admin_user) {
    return request('post', '/api/danta_stats_cron_status', { admin_user });
  },
  // statsDaily 수동 실행 — { date?: 'YYYY-MM-DD' }
  run_daily(admin_user, date) {
    return request('post', '/api/danta_stats_run_daily', { admin_user, date });
  },
  // statsMonthly 수동 실행 — { ym?: 'YYYY-MM' }
  run_monthly(admin_user, ym) {
    return request('post', '/api/danta_stats_run_monthly', { admin_user, ym });
  },
}

export const carrygold_chat = {
  get_chat_list(admin_user, count) {
    return request('post', '/api/carrygold/get_chat_list', { admin_user, count });
  },
  get_chat_list_by_user(admin_user, user_id, count) {
    return request('post', '/api/carrygold/get_chat_list_by_user', { admin_user, user_id, count });
  },
  get_chat_report_list(admin_user, user_id, count) {
    return request('post', '/api/carrygold/get_chat_report_list', { admin_user, user_id, count });
  },
  get_chat_user_info(admin_user, user_id) {
    return request('post', '/api/carrygold/get_chat_user_info', { admin_user, user_id });
  },
  ban_chat_user(admin_user, user_id, ban_hours) {
    return request('post', '/api/carrygold/ban_chat_user', { admin_user, user_id, ban_hours });
  },
  unban_chat_user(admin_user, user_id) {
    return request('post', '/api/carrygold/unban_chat_user', { admin_user, user_id });
  },
}
//#endregion



// [PROMBOOK]
export const prombook = {
  // 프롬프트
  search_prompt(keyword, is_hidden, page, page_size, featured_slot) {
    return request('post', '/api/prombook_search_prompt', { keyword, is_hidden, page, page_size, featured_slot })
  },
  get_prompt_detail(id) {
    return request('post', '/api/prombook_get_prompt_detail', { id })
  },
  create_prompt(payload) {
    return request('post', '/api/prombook_create_prompt', payload)
  },
  update_prompt(payload) {
    return request('post', '/api/prombook_update_prompt', payload)
  },
  hide_prompt(id, is_hidden) {
    return request('post', '/api/prombook_hide_prompt', { id, is_hidden })
  },
  delete_prompt(id) {
    return request('post', '/api/prombook_delete_prompt', { id })
  },
  // 피드
  search_feed(keyword, is_hidden, page, page_size) {
    return request('post', '/api/prombook_search_feed', { keyword, is_hidden, page, page_size })
  },
  get_feed_detail(id) { return request('post', '/api/prombook_get_feed_detail', { id }) },
  hide_feed(id, is_hidden) { return request('post', '/api/prombook_hide_feed', { id, is_hidden }) },
  delete_feed(id) { return request('post', '/api/prombook_delete_feed', { id }) },
  // 유저
  search_user(search_type, keyword, status, page, page_size) {
    return request('post', '/api/prombook_search_user', { search_type, keyword, status, page, page_size })
  },
  get_user_detail(user_id) { return request('post', '/api/prombook_get_user_detail', { user_id }) },
  ban_user(user_id, reason) { return request('post', '/api/prombook_ban_user', { user_id, reason }) },
  unban_user(user_id) { return request('post', '/api/prombook_unban_user', { user_id }) },
  get_user_count() { return request('post', '/api/prombook_get_user_count', {}) },
  // 공지
  list_notice(page, page_size) { return request('post', '/api/prombook_list_notice', { page, page_size }) },
  get_notice(id) { return request('post', '/api/prombook_get_notice', { id }) },
  save_notice(payload) { return request('post', '/api/prombook_save_notice', payload) },
  delete_notice(id) { return request('post', '/api/prombook_delete_notice', { id }) },
  // 이벤트
  list_event(event_type, is_active, page, page_size) {
    return request('post', '/api/prombook_list_event', { event_type, is_active, page, page_size })
  },
  get_event(id) { return request('post', '/api/prombook_get_event', { id }) },
  save_event(payload) { return request('post', '/api/prombook_save_event', payload) },
  delete_event(id) { return request('post', '/api/prombook_delete_event', { id }) },
  // 구매내역
  list_buy_history(filters) { return request('post', '/api/prombook_list_buy_history', filters) },
  get_buy_history_detail(id) { return request('post', '/api/prombook_get_buy_history_detail', { id }) },
  // 설정
  list_setting() { return request('post', '/api/prombook_list_setting', {}) },
  get_setting(key) { return request('post', '/api/prombook_get_setting', { key }) },
  save_setting(payload) { return request('post', '/api/prombook_save_setting', payload) },
  delete_setting(key) { return request('post', '/api/prombook_delete_setting', { key }) },
  // 우편 (POINT 발송) — mail_info = { point, title, message }
  create_mail(payload) { return request('post', '/api/prombook_create_mail', payload) },
  get_mail_list_recent() { return request('post', '/api/prombook_get_mail_list_recent', {}) },
  create_mail_multi(payload) { return request('post', '/api/prombook_create_mail_multi', payload) },
  // 메인 노출 (featured)
  list_featured(slot) { return request('post', '/api/prombook_list_featured', { slot }) },
  search_for_add(slot, keyword, page, page_size) {
    return request('post', '/api/prombook_search_for_add', { slot, keyword, page, page_size })
  },
  add_featured(slot, prompt_id, created_by) {
    return request('post', '/api/prombook_add_featured', { slot, prompt_id, created_by })
  },
  remove_featured(id) { return request('post', '/api/prombook_remove_featured', { id }) },
  remove_featured_by_prompt(slot, prompt_id) {
    return request('post', '/api/prombook_remove_featured_by_prompt', { slot, prompt_id })
  },
  update_featured(payload) { return request('post', '/api/prombook_update_featured', payload) },
  reorder_featured(slot, ordered_ids) {
    return request('post', '/api/prombook_reorder_featured', { slot, ordered_ids })
  },
}






